import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import { fetchData } from './fetcher';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
    [_ in K]?: never;
};
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
};

export type AcceptInvitationsResult = {
    acceptedInvitations?: Maybe<Array<Maybe<Invitation>>>;
};

export type AccessCode = {
    accessCode: Scalars['String']['output'];
    accessCodeCapacity: Scalars['Int']['output'];
    accessCodeCapacityUsed: Scalars['Int']['output'];
};

export type AccessType = 'ACCESS_CODE' | 'STUDENT_ROSTER';

export type ActivityNote = {
    description?: Maybe<Scalars['String']['output']>;
    timestamp?: Maybe<Scalars['Int']['output']>;
    updated_by?: Maybe<Scalars['String']['output']>;
};

/**
 *   NB: Instructors need to be associated to a Classroom for AuthZ.
 *  As for TCs, they should have a relationship with both the providerArn of the Classroom
 *  And the subProviderArn for student relationship partitioning.
 */
export type AddStudentsToClassroomRosterInput = {
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
    /**   Used for checking TC AuthZ */
    subProviderArn?: InputMaybe<Scalars['String']['input']>;
    users: Array<InputMaybe<UserInput>>;
};

export type AggregationField = 'country' | 'courseTitle' | 'langLocale';

export type AmsDeliverySession = {
    endTime?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    learningActivity?: Maybe<LearningActivity>;
    startTime?: Maybe<Scalars['Int']['output']>;
};

export type AttendanceRecord = {
    amsDeliverySession: AmsDeliverySession;
    attendanceDurationPercentage?: Maybe<Scalars['Float']['output']>;
    attendanceStatus: AttendanceStatus;
    id: Scalars['ID']['output'];
    learner?: Maybe<User>;
    version: Scalars['Int']['output'];
};

export type AttendanceStatus =
    | 'ATTENDED'
    | 'NOT_MARKED'
    | 'NO_SHOW'
    | 'PARTIALLY_ATTENDED'
    | 'REMOVED';

export type AttributeAggregation = {
    countType?: Maybe<CountType>;
    items: Array<Maybe<AttributeAggregationItem>>;
};

export type AttributeAggregationItem = {
    count: Scalars['Int']['output'];
    value: Scalars['String']['output'];
};

export type BatchGetUserInfoInput = {
    classroomId: Scalars['String']['input'];
    learningActivityID: Scalars['ID']['input'];
    options: UserQueryOptionsInput;
    providerArn: Scalars['String']['input'];
    queryMode: UserQueryMode;
    users: Array<InputMaybe<Scalars['String']['input']>>;
};

export type BatchGetUserInfoResult = {
    failedUsers?: Maybe<Array<Maybe<FailedGetUserInfoResult>>>;
    users?: Maybe<Array<Maybe<GetUserInfoResult>>>;
};

export type BlueprintData = {
    arn: Scalars['String']['output'];
    blueprintName: Scalars['String']['output'];
};

export type Csat = {
    completed_responses: Scalars['Int']['output'];
    instructor_score: Scalars['Float']['output'];
    overall_score: Scalars['Float']['output'];
};

export type CallToActionIconPosition = 'left' | 'right';

export type CallToActionType = 'flat' | 'link' | 'primary' | 'secondary';

export type CallsToAction = {
    actionType: CallToActionType;
    icon?: Maybe<Scalars['String']['output']>;
    iconPosition?: Maybe<CallToActionIconPosition>;
    label: Scalars['String']['output'];
    locationType: LocationType;
    url?: Maybe<Scalars['String']['output']>;
};

export type CancelStudentTrainingsInput = {
    blueprintArn: Scalars['String']['input'];
    classroomId: Scalars['String']['input'];
    clientToken?: InputMaybe<Scalars['String']['input']>;
    providerArn?: InputMaybe<Scalars['String']['input']>;
    userKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CancelStudentTrainingsResult = {
    batchId: Scalars['String']['output'];
    created: Scalars['Int']['output'];
};

export type Classroom = {
    accessCodes?: Maybe<Array<Maybe<AccessCode>>>;
    accessType?: Maybe<AccessType>;
    callsToAction?: Maybe<Array<Maybe<CallsToAction>>>;
    classCapacity?: Maybe<Scalars['Int']['output']>;
    classroomArn: Scalars['String']['output'];
    classroomId: Scalars['String']['output'];
    courseAbstract?: Maybe<Scalars['String']['output']>;
    courseDescription?: Maybe<Scalars['String']['output']>;
    courseId: Scalars['String']['output'];
    courseLevel?: Maybe<Scalars['Int']['output']>;
    courseTitle?: Maybe<Scalars['String']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    endsOn: Scalars['Int']['output'];
    isCancellable?: Maybe<Scalars['Boolean']['output']>;
    langLocale: Scalars['String']['output'];
    learningActivityID?: Maybe<Scalars['String']['output']>;
    locationData?: Maybe<Location>;
    providerArn?: Maybe<Scalars['String']['output']>;
    startsOn: Scalars['Int']['output'];
    studentCount?: Maybe<Scalars['Int']['output']>;
    studentGuide?: Maybe<StudentGuide>;
    subProviderCapacity?: Maybe<Array<Maybe<SubProviderCapacity>>>;
    supportedRegions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ClassroomFilter = {
    after?: InputMaybe<Scalars['String']['input']>;
    attribute: OrderingAttribute;
    before?: InputMaybe<Scalars['String']['input']>;
};

export type ClassroomFilterEnum = 'ACTIVE' | 'FUTURE';

export type ClassroomInstructorRelationship = 'instructor';

export type ClassroomListAggregations = {
    country?: Maybe<AttributeAggregation>;
    courseTitle?: Maybe<AttributeAggregation>;
    langLocale?: Maybe<AttributeAggregation>;
};

export type ClassroomListFilterOptions = {
    classEndDate?: InputMaybe<DateRange>;
    classStartDate?: InputMaybe<DateRange>;
    country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    courseTitle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    createdByEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    instructorEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClassroomListInstructorFilterOptions = {
    classEndDate?: InputMaybe<DateRange>;
    classStartDate?: InputMaybe<DateRange>;
    country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    courseTitle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    createdByEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClassroomListPaginationOptions = {
    fromItemIndex?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassroomListSortOptions = {
    ascOrder?: InputMaybe<Scalars['Boolean']['input']>;
    attribute?: InputMaybe<OrderingAttribute>;
};

export type ClassroomLocationType = 'physical' | 'virtual';

export type ClassroomRelationship = 'instructor' | 'student';

export type ClassroomUser = {
    eKitLicensedProviderArn?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    hasAcceptedInvitation?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    userKey?: Maybe<Scalars['String']['output']>;
};

export type ClassroomV2 = {
    classroomArn?: Maybe<Scalars['String']['output']>;
    courseId: Scalars['String']['output'];
    courseTitle?: Maybe<Scalars['String']['output']>;
    createdByEmail?: Maybe<Scalars['String']['output']>;
    endsOn: Scalars['Int']['output'];
    instructorEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    langLocale: Scalars['String']['output'];
    locationData: Location;
    providerArn: Scalars['String']['output'];
    startsOn: Scalars['Int']['output'];
};

export type ClassroomV2Input = {
    accessType?: InputMaybe<AccessType>;
    courseId: Scalars['String']['input'];
    endsOn: Scalars['Int']['input'];
    langLocale: Scalars['String']['input'];
    learningActivityID?: InputMaybe<Scalars['String']['input']>;
    locationData: LocationInput;
    providerArn: Scalars['String']['input'];
    startsOn: Scalars['Int']['input'];
};

export type Collection = {
    collectionArn: Scalars['String']['output'];
    collectionTitle: Scalars['String']['output'];
    courseTemplatePk?: Maybe<Scalars['String']['output']>;
    supportedLangLocales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ContentAvailability = 'ACTIVE' | 'INACTIVE';

export type ContentStatus = 'CREATING' | 'FAILED' | 'VALIDATED';

export type ContentType = 'GUIDES' | 'JAMS' | 'LABS';

export type ContentTypeEnum = 'SPL';

export type CountType = 'at_least' | 'exact';

export type Course = {
    abstract?: Maybe<Scalars['String']['output']>;
    courseId: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    langLocale: Scalars['String']['output'];
    level?: Maybe<Scalars['Int']['output']>;
    title: Scalars['String']['output'];
};

export type CourseIdentifier = {
    courseId: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type CourseResourceData = {
    description?: Maybe<Scalars['String']['output']>;
    locale: Scalars['String']['output'];
    title?: Maybe<Scalars['String']['output']>;
};

export type CourseVersion = {
    availability: ContentAvailability;
    blueprintData?: Maybe<Array<Maybe<BlueprintData>>>;
    contentTypes?: Maybe<Array<Maybe<ContentType>>>;
    contentVersion?: Maybe<Scalars['String']['output']>;
    courseName: Scalars['String']['output'];
    courseVersionId: Scalars['String']['output'];
    createdOn: Scalars['Int']['output'];
    jamConfig?: Maybe<JamConfig>;
    resourceData?: Maybe<Array<Maybe<CourseResourceData>>>;
    status: ContentStatus;
    supportedLocales: Array<Maybe<Scalars['String']['output']>>;
};

export type CourseVersionListItem = {
    availability: ContentAvailability;
    courseId: Scalars['String']['output'];
    createdOn: Scalars['Int']['output'];
    status: ContentStatus;
    versionId: Scalars['String']['output'];
};

export type CourseVirtualSkuInfoInput = {
    collectionVersionArn: Scalars['String']['input'];
    langLocale: Scalars['String']['input'];
    providerArn: Scalars['String']['input'];
};

export type CourseVirtualSkuInfoResult = {
    availableQuantity: Scalars['Int']['output'];
    productId?: Maybe<Scalars['String']['output']>;
};

export type CreateClassroomInput = {
    accessCode?: InputMaybe<Scalars['String']['input']>;
    addressLine1?: InputMaybe<Scalars['String']['input']>;
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    classCapacity: Scalars['Int']['input'];
    country?: InputMaybe<Scalars['String']['input']>;
    courseId: Scalars['String']['input'];
    endsOn: Scalars['Int']['input'];
    langLocale: Scalars['String']['input'];
    locationType: ClassroomLocationType;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    providerArn?: InputMaybe<Scalars['String']['input']>;
    startsOn: Scalars['Int']['input'];
    state?: InputMaybe<Scalars['String']['input']>;
    timezone: Scalars['String']['input'];
    transactionToken?: InputMaybe<Scalars['String']['input']>;
    virtualUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClassroomRelationshipsInput = {
    classroomId: Scalars['String']['input'];
    providerArn: Scalars['String']['input'];
    relationship: ClassroomInstructorRelationship;
    users: Array<InputMaybe<UserInput>>;
};

export type CreateClassroomResult = {
    classroomArn: Scalars['String']['output'];
    classroomId: Scalars['String']['output'];
};

export type CreateClassroomV2Input = {
    accessCode?: InputMaybe<Scalars['String']['input']>;
    classCapacity: Scalars['Int']['input'];
    classroom: ClassroomV2Input;
    clientRequestToken: Scalars['String']['input'];
    jamEventConfig?: InputMaybe<JamEventConfig>;
    subProviderCapacity?: InputMaybe<Array<InputMaybe<SubProviderCapacityInput>>>;
};

export type CreateStudentTrainingsInput = {
    blueprintArn: Scalars['String']['input'];
    classroomId: Scalars['String']['input'];
    clientToken: Scalars['String']['input'];
    pooledLabCount?: InputMaybe<Scalars['Int']['input']>;
    preferredLangLocale: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
    targetRegions?: InputMaybe<Array<Scalars['String']['input']>>;
    userKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateStudentTrainingsResult = {
    batchId?: Maybe<Scalars['String']['output']>;
    created?: Maybe<Scalars['Int']['output']>;
    labPoolBatchInfo?: Maybe<LabPoolBatchInfo>;
};

export type Customer = {
    customer_name?: Maybe<Scalars['String']['output']>;
    sfdc_account_id?: Maybe<Scalars['String']['output']>;
    training_briefing?: Maybe<CustomerTrainingBriefing>;
};

export type CustomerTrainingBriefing = {
    motivations_for_using_aws?: Maybe<Scalars['String']['output']>;
    special_needs_for_training_delivery?: Maybe<Scalars['String']['output']>;
    what_the_customer_does?: Maybe<Scalars['String']['output']>;
    where_are_they_in_their_cloud_journey?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
    after?: InputMaybe<Scalars['Int']['input']>;
    before?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliverySession = {
    end_timestamp?: Maybe<Scalars['Int']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    start_timestamp?: Maybe<Scalars['Int']['output']>;
};

export type EvaluationStatus = 'COMPLETED' | 'INCOMPLETE' | 'NOT_REQUIRED';

export type Event = {
    body: Scalars['String']['input'];
};

export type EventReason = 'MAINTENANCE' | 'UNKNOWN';

export type EventType = 'PLANNED' | 'UNPLANNED';

export type ExcludeUserInput = {
    classroomId: Scalars['String']['input'];
    clientRequestToken: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
    relationship: ClassroomRelationship;
    user: UserInput;
};

export type FailedGetUserInfoResult = {
    error?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlag = {
    enabled: Scalars['Boolean']['output'];
    flag: Scalars['String']['output'];
};

export type FulFillmentError = {
    message?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type FulfillmentStatus = 'complete' | 'error' | 'pending' | 'updating';

export type GetClassAttendanceInput = {
    classroomId: Scalars['String']['input'];
    cursor?: InputMaybe<Scalars['String']['input']>;
    includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
    learningActivityID: Scalars['ID']['input'];
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    providerArn: Scalars['String']['input'];
};

export type GetClassAttendanceResult = {
    learningActivityAttendanceRecords: Array<Maybe<LearningActivityAttendanceRecord>>;
    pageInfo?: Maybe<PageInfo>;
};

export type GetClassroomResult = {
    classroom: Classroom;
    content: Array<Maybe<Training>>;
    course: Course;
    jamTrainings?: Maybe<JamTrainings>;
};

export type GetCourseVersionResult = {
    courseVersion?: Maybe<CourseVersion>;
};

export type GetCourseVersionsInput = {
    courseId: Scalars['String']['input'];
    langLocale?: InputMaybe<Scalars['String']['input']>;
    maxResults?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    providerArn: Scalars['String']['input'];
};

export type GetCourseVersionsResult = {
    courseVersions?: Maybe<Array<Maybe<CourseVersionListItem>>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type GetIngressUrlInput = {
    classroomId: Scalars['String']['input'];
    instructorUserKey: Scalars['String']['input'];
    labId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
    studentUserKey: Scalars['String']['input'];
};

export type GetIngressUrlResult = {
    consoleUrl: Scalars['String']['output'];
    endsOn: Scalars['Int']['output'];
    labId: Scalars['String']['output'];
    status: Scalars['String']['output'];
};

export type GetLearningActivityInput = {
    classroomId: Scalars['String']['input'];
    learningActivityID: Scalars['ID']['input'];
    providerArn: Scalars['String']['input'];
};

export type GetProviderArnsResult = {
    providers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GetProviderInput = {
    providerArn: Scalars['String']['input'];
};

export type GetProviderReportInput = {
    providerArn: Scalars['String']['input'];
    reportId: Scalars['String']['input'];
};

export type GetProviderReportResult = {
    presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type GetProviderResult = {
    provider: Provider;
};

export type GetServiceSchedule = {
    domain: Scalars['String']['output'];
    endTime: Scalars['Int']['output'];
    event: EventReason;
    service: Scalars['String']['output'];
    startTime: Scalars['Int']['output'];
    type: EventType;
};

export type GetServiceScheduleInput = {
    providerArn: Scalars['String']['input'];
};

export type GetServiceScheduleResult = {
    schedules: Array<Maybe<GetServiceSchedule>>;
};

export type GetStudentTrainingsByClassroomId = {
    studentTrainings: Array<Maybe<StudentTraining>>;
};

export type GetTrainingConfigurationInput = {
    /**   is the classroomArn */
    classroomId?: InputMaybe<Scalars['String']['input']>;
    /**   context needs to migrate to this */
    contentArn: Scalars['String']['input'];
    context: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserInfoResult = {
    emailAddress?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    licenses?: Maybe<UserLicenseNodes>;
    organizations?: Maybe<UserOrganizationNodes>;
};

export type GrimsbyCourse = {
    id: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type Instructor = {
    email?: Maybe<Scalars['String']['output']>;
    pk?: Maybe<Scalars['ID']['output']>;
    role?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type Invitation = {
    email: Scalars['String']['output'];
    invitationArn: Scalars['String']['output'];
    relationship: Scalars['String']['output'];
    resourceArn: Scalars['String']['output'];
    status: Scalars['String']['output'];
};

export type JamConfig = {
    challengeSetID: Scalars['String']['output'];
};

export type JamEventConfig = {
    endsOn: Scalars['Int']['input'];
    startsOn: Scalars['Int']['input'];
    teamSize: Scalars['Int']['input'];
};

export type JamEventStatus = 'CANCELLED' | 'ENDED' | 'ERROR' | 'NOT_STARTED' | 'ONGOING';

export type JamEventUpdateConfig = {
    endsOn: Scalars['Int']['input'];
    startsOn: Scalars['Int']['input'];
    teamSize: Scalars['Int']['input'];
    trainingId: Scalars['String']['input'];
};

export type JamFulFillmentError = {
    code?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
};

export type JamMetaData = {
    adminEventURL?: Maybe<Scalars['String']['output']>;
    endsOn?: Maybe<Scalars['Int']['output']>;
    eventCode?: Maybe<Scalars['String']['output']>;
    eventId?: Maybe<Scalars['String']['output']>;
    eventStatus?: Maybe<JamEventStatus>;
    eventURL?: Maybe<Scalars['String']['output']>;
    maxExpectedParticipants?: Maybe<Scalars['Int']['output']>;
    maxTeamSize?: Maybe<Scalars['Int']['output']>;
    startsOn?: Maybe<Scalars['Int']['output']>;
    testCloneEventCode?: Maybe<Scalars['String']['output']>;
    testCloneEventId?: Maybe<Scalars['String']['output']>;
    testCloneEventSuffix?: Maybe<Scalars['String']['output']>;
    testEventURL?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type JamTrainingFulfillmentStatus = 'COMPLETE' | 'ERROR' | 'PENDING' | 'UPDATING';

export type JamTrainingRecord = {
    contentId: Scalars['String']['output'];
    context: Scalars['String']['output'];
    created?: Maybe<Scalars['Int']['output']>;
    fulfillmentError?: Maybe<JamFulFillmentError>;
    fulfillmentStatus?: Maybe<JamTrainingFulfillmentStatus>;
    isActive: Scalars['Boolean']['output'];
    lastUpdate?: Maybe<Scalars['Int']['output']>;
    metaData?: Maybe<JamMetaData>;
    requestClientToken: Scalars['String']['output'];
    trainingId: Scalars['String']['output'];
    trainingType: Scalars['String']['output'];
};

export type JamTrainings = {
    nextToken?: Maybe<Scalars['String']['output']>;
    trainings?: Maybe<Array<Maybe<JamTrainingRecord>>>;
};

export type LabPoolBatchInfo = {
    batchId: Scalars['String']['output'];
    createdTime: Scalars['Int']['output'];
};

export type LearnerAttendanceInput = {
    attendanceDurationPercentage?: InputMaybe<Scalars['Int']['input']>;
    learner: Scalars['String']['input'];
};

export type LearningActivity = {
    activity_audience?: Maybe<Scalars['String']['output']>;
    activity_modality?: Maybe<Scalars['String']['output']>;
    activity_name?: Maybe<Scalars['String']['output']>;
    activity_status?: Maybe<Scalars['String']['output']>;
    activity_type?: Maybe<Scalars['String']['output']>;
    attendedCounter?: Maybe<Scalars['Int']['output']>;
    class_size?: Maybe<Scalars['Int']['output']>;
    classrooms_arn?: Maybe<Scalars['String']['output']>;
    classrooms_student_url?: Maybe<Scalars['String']['output']>;
    course_name?: Maybe<Scalars['String']['output']>;
    csat?: Maybe<Csat>;
    customers?: Maybe<Array<Maybe<Customer>>>;
    delivery_address_1?: Maybe<Scalars['String']['output']>;
    delivery_address_2?: Maybe<Scalars['String']['output']>;
    delivery_city?: Maybe<Scalars['String']['output']>;
    delivery_country?: Maybe<Scalars['String']['output']>;
    delivery_geo?: Maybe<Scalars['String']['output']>;
    delivery_language?: Maybe<Scalars['String']['output']>;
    delivery_postal_code?: Maybe<Scalars['String']['output']>;
    delivery_region?: Maybe<Scalars['String']['output']>;
    delivery_sessions?: Maybe<Array<Maybe<DeliverySession>>>;
    delivery_state?: Maybe<Scalars['String']['output']>;
    delivery_timezone?: Maybe<Scalars['String']['output']>;
    instructor_notes?: Maybe<Array<ActivityNote>>;
    instructors?: Maybe<Array<Maybe<Instructor>>>;
    lms_type?: Maybe<Scalars['String']['output']>;
    pk?: Maybe<Scalars['ID']['output']>;
    program?: Maybe<Scalars['String']['output']>;
    record_type?: Maybe<Scalars['String']['output']>;
    registrationCounter?: Maybe<Scalars['Int']['output']>;
    v_ilt_id?: Maybe<Scalars['String']['output']>;
    v_ilt_meeting_id?: Maybe<Scalars['String']['output']>;
    v_ilt_type?: Maybe<Scalars['String']['output']>;
};

export type LearningActivityAttendanceRecord = {
    deliverySessionAttendanceRecords: Array<Maybe<AttendanceRecord>>;
    learner: LearningActivityUser;
    learningActivityAttendanceStatus: AttendanceStatus;
};

export type LearningActivityUser = UserInterface & {
    emailAddress: Scalars['String']['output'];
    evaluationStatus?: Maybe<EvaluationStatus>;
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    licenses?: Maybe<UserLicenseNodes>;
    organizations?: Maybe<UserOrganizationNodes>;
};

export type LicenseType = 'B2B' | 'B2I';

export type ListClassroomRelationshipsInput = {
    classroomId: Scalars['String']['input'];
    providerArn: Scalars['String']['input'];
    relationship: ClassroomRelationship;
};

export type ListClassroomRelationshipsResult = {
    classroomUsers: Array<Maybe<ClassroomUser>>;
    emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ListClassroomsInput = {
    filter?: InputMaybe<ClassroomFilterEnum>;
    fullFilter?: InputMaybe<ClassroomFilter>;
    maxResults?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    providerArn: Scalars['String']['input'];
};

export type ListClassroomsResult = {
    classrooms?: Maybe<Array<Maybe<ClassroomV2>>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ListClassroomsV2Result = {
    aggregations?: Maybe<ClassroomListAggregations>;
    classrooms?: Maybe<Array<Maybe<ClassroomV2>>>;
    count?: Maybe<Scalars['Int']['output']>;
    countType?: Maybe<CountType>;
};

export type ListCoursesInput = {
    providerArn: Scalars['String']['input'];
};

export type ListCoursesResult = {
    courses: Array<Maybe<GrimsbyCourse>>;
};

export type ListInstructorClassroomsV2Input = {
    aggregations?: InputMaybe<Array<InputMaybe<AggregationField>>>;
    filterOptions?: InputMaybe<ClassroomListInstructorFilterOptions>;
    paginationOptions?: InputMaybe<ClassroomListPaginationOptions>;
    providerArn: Scalars['String']['input'];
    sortOptions?: InputMaybe<ClassroomListSortOptions>;
};

export type ListMajorCourseVersionsInput = {
    grimsbyCourseId: Scalars['String']['input'];
    langLocale?: InputMaybe<Scalars['String']['input']>;
    maxResults?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    providerArn: Scalars['String']['input'];
};

export type ListMajorCourseVersionsResult = {
    collections: Array<Maybe<Collection>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ListProviderClassroomsV2Input = {
    aggregations?: InputMaybe<Array<InputMaybe<AggregationField>>>;
    filterOptions?: InputMaybe<ClassroomListFilterOptions>;
    paginationOptions?: InputMaybe<ClassroomListPaginationOptions>;
    providerArn: Scalars['String']['input'];
    sortOptions?: InputMaybe<ClassroomListSortOptions>;
};

export type ListProviderReportsInput = {
    filter?: InputMaybe<ProviderReportFilter>;
    maxResults?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    providerArn: Scalars['String']['input'];
};

export type ListProviderReportsResult = {
    iltReports?: Maybe<Array<Maybe<ProviderReport>>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ListUserRelationshipsInput = {
    providerArn: Scalars['String']['input'];
};

export type ListUserRelationshipsResult = {
    relationships?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Location = {
    locationType: ClassroomLocationType;
    physicalAddress?: Maybe<PhysicalAddress>;
    source?: Maybe<LocationSource>;
    timezone: Scalars['String']['output'];
    virtualUrl?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
    locationType: ClassroomLocationType;
    physicalAddress?: InputMaybe<PhysicalAddressInput>;
    source?: InputMaybe<LocationSource>;
    timezone: Scalars['String']['input'];
    virtualUrl?: InputMaybe<Scalars['String']['input']>;
};

export type LocationSource = 'DEFAULT' | 'LADS';

export type LocationType = 'footer' | 'header' | 'training';

export type MarkAttendanceInput = {
    classroomId: Scalars['String']['input'];
    deliverySessionId: Scalars['String']['input'];
    learnerAttendance: Array<LearnerAttendanceInput>;
    learningActivityID: Scalars['String']['input'];
    providerArn: Scalars['String']['input'];
};

export type MarkAttendanceResult = {
    attendanceRecords: Array<Maybe<AttendanceRecord>>;
};

export type Mutation = {
    acceptInvitations: AcceptInvitationsResult;
    addStudentsToClassroomRoster: StatusCode;
    cancelClassroom: ClassroomV2;
    cancelStudentTrainings: CancelStudentTrainingsResult;
    clientLog: StatusCode;
    createClassroom: CreateClassroomResult;
    createClassroomRelationships: StatusCode;
    createClassroomV2: CreateClassroomResult;
    createStudentTrainings: CreateStudentTrainingsResult;
    excludeUser: Invitation;
    markAttendance: MarkAttendanceResult;
    putTrainingConfiguration: StatusCode;
    resetResources: StatusCode;
    updateClassroom: UpdateClassroomResult;
    updateClassroomV2: UpdateClassroomResult;
    updateTrainingPermissions: Permission;
};

export type MutationAddStudentsToClassroomRosterArgs = {
    input: AddStudentsToClassroomRosterInput;
};

export type MutationCancelClassroomArgs = {
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelStudentTrainingsArgs = {
    input: CancelStudentTrainingsInput;
};

export type MutationClientLogArgs = {
    input: Event;
};

export type MutationCreateClassroomArgs = {
    input: CreateClassroomInput;
};

export type MutationCreateClassroomRelationshipsArgs = {
    input: CreateClassroomRelationshipsInput;
};

export type MutationCreateClassroomV2Args = {
    input: CreateClassroomV2Input;
};

export type MutationCreateStudentTrainingsArgs = {
    input: CreateStudentTrainingsInput;
};

export type MutationExcludeUserArgs = {
    input: ExcludeUserInput;
};

export type MutationMarkAttendanceArgs = {
    input: MarkAttendanceInput;
};

export type MutationPutTrainingConfigurationArgs = {
    input: PutTrainingConfigurationInput;
};

export type MutationUpdateClassroomArgs = {
    input: UpdateClassroomInput;
};

export type MutationUpdateClassroomV2Args = {
    input: UpdateClassroomV2Input;
};

export type MutationUpdateTrainingPermissionsArgs = {
    input: PermissionInput;
};

export type OrderingAttribute = 'courseTitle' | 'endsOn' | 'startsOn';

export type PageInfo = {
    cursor?: Maybe<Scalars['String']['output']>;
    size?: Maybe<Scalars['Int']['output']>;
};

export type Permission = {
    activeTrainings?: Maybe<Array<Scalars['String']['output']>>;
    classroomId: Scalars['String']['output'];
    providerArn?: Maybe<Scalars['String']['output']>;
    status: Scalars['String']['output'];
};

export type PermissionInput = {
    arn: Array<InputMaybe<Scalars['String']['input']>>;
    classroomId: Scalars['ID']['input'];
    idempotencyToken: Scalars['String']['input'];
    isActive: Scalars['Boolean']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type PhysicalAddress = {
    addressLine1: Scalars['String']['output'];
    addressLine2?: Maybe<Scalars['String']['output']>;
    city: Scalars['String']['output'];
    country: Scalars['String']['output'];
    postalCode: Scalars['String']['output'];
    state: Scalars['String']['output'];
};

export type PhysicalAddressInput = {
    addressLine1: Scalars['String']['input'];
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city: Scalars['String']['input'];
    country: Scalars['String']['input'];
    postalCode: Scalars['String']['input'];
    state: Scalars['String']['input'];
};

export type ProductModality = 'DIGITAL';

export type Provider = {
    arn: Scalars['String']['output'];
    name: Scalars['String']['output'];
    subProviderData?: Maybe<Array<Maybe<SubProviderData>>>;
    type: ProviderType;
};

export type ProviderMetaData = {
    isParentProvider: Scalars['Boolean']['output'];
    parentProviderArn: Scalars['String']['output'];
};

export type ProviderReport = {
    createdDate: Scalars['String']['output'];
    reportDate: Scalars['String']['output'];
    reportDescription: Scalars['String']['output'];
    reportId?: Maybe<Scalars['String']['output']>;
    reportName: Scalars['String']['output'];
};

export type ProviderReportFilter = {
    reportDate?: InputMaybe<Scalars['String']['input']>;
    reportDateBefore: Scalars['String']['input'];
    reportDateOnOrAfter?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderType = 'ATP' | 'DIRECT';

export type PutTrainingConfigurationInput = {
    /**   is the classroomArn */
    classroomId?: InputMaybe<Scalars['String']['input']>;
    configuration?: InputMaybe<SplConfigurationInput>;
    /**   context needs to migrate to this */
    contentArn: Scalars['String']['input'];
    contentType: ContentTypeEnum;
    context: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
    batchGetUserInfo: BatchGetUserInfoResult;
    courseVirtualSKUInfo: CourseVirtualSkuInfoResult;
    getClassAttendance: GetClassAttendanceResult;
    getClassroom: GetClassroomResult;
    getCourseVersion: GetCourseVersionResult;
    getCourseVersions: GetCourseVersionsResult;
    getFeatureFlags?: Maybe<Array<FeatureFlag>>;
    getIngressUrl: GetIngressUrlResult;
    getLearningActivity: LearningActivity;
    getProvider: GetProviderResult;
    getProviderArns: GetProviderArnsResult;
    getProviderReport: GetProviderReportResult;
    getServiceSchedule: GetServiceScheduleResult;
    getStudentTrainingsByClassroomId: GetStudentTrainingsByClassroomId;
    getTrainingConfiguration: TrainingConfiguration;
    listClassroomRelationships: ListClassroomRelationshipsResult;
    listCourses: ListCoursesResult;
    listInstructorClassroomsV2: ListClassroomsV2Result;
    listMajorCourseVersions: ListMajorCourseVersionsResult;
    listProviderClassrooms: ListClassroomsResult;
    listProviderClassroomsV2: ListClassroomsV2Result;
    listProviderReports: ListProviderReportsResult;
    listUserClassrooms: ListClassroomsResult;
    listUserRelationships: ListUserRelationshipsResult;
    requiresReset: RequiresResetResult;
};

export type QueryBatchGetUserInfoArgs = {
    input: BatchGetUserInfoInput;
};

export type QueryCourseVirtualSkuInfoArgs = {
    input: CourseVirtualSkuInfoInput;
};

export type QueryGetClassAttendanceArgs = {
    input: GetClassAttendanceInput;
};

export type QueryGetClassroomArgs = {
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCourseVersionArgs = {
    courseVersionId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCourseVersionsArgs = {
    input: GetCourseVersionsInput;
};

export type QueryGetIngressUrlArgs = {
    input: GetIngressUrlInput;
};

export type QueryGetLearningActivityArgs = {
    input: GetLearningActivityInput;
};

export type QueryGetProviderArgs = {
    input: GetProviderInput;
};

export type QueryGetProviderReportArgs = {
    input: GetProviderReportInput;
};

export type QueryGetServiceScheduleArgs = {
    input: GetServiceScheduleInput;
};

export type QueryGetStudentTrainingsByClassroomIdArgs = {
    accessType?: InputMaybe<AccessType>;
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTrainingConfigurationArgs = {
    input: GetTrainingConfigurationInput;
};

export type QueryListClassroomRelationshipsArgs = {
    input: ListClassroomRelationshipsInput;
};

export type QueryListCoursesArgs = {
    input: ListCoursesInput;
};

export type QueryListInstructorClassroomsV2Args = {
    input: ListInstructorClassroomsV2Input;
};

export type QueryListMajorCourseVersionsArgs = {
    input?: InputMaybe<ListMajorCourseVersionsInput>;
};

export type QueryListProviderClassroomsArgs = {
    input: ListClassroomsInput;
};

export type QueryListProviderClassroomsV2Args = {
    input: ListProviderClassroomsV2Input;
};

export type QueryListProviderReportsArgs = {
    input: ListProviderReportsInput;
};

export type QueryListUserClassroomsArgs = {
    input: ListClassroomsInput;
};

export type QueryListUserRelationshipsArgs = {
    input: ListUserRelationshipsInput;
};

export type RequiresResetResult = {
    requiresReset: Scalars['Boolean']['output'];
};

export type SplConfiguration = {
    targetRegions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SplConfigurationInput = {
    targetRegions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StatusCode = {
    statusCode?: Maybe<Scalars['Int']['output']>;
};

export type StudentGuide = {
    custom_vbid?: Maybe<Scalars['String']['output']>;
};

export type StudentTraining = {
    arn?: Maybe<Scalars['String']['output']>;
    bunsenLabStatus?: Maybe<Scalars['String']['output']>;
    context: Scalars['String']['output'];
    created?: Maybe<Scalars['Int']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    fulfillmentError?: Maybe<FulFillmentError>;
    fulfillmentStatus?: Maybe<FulfillmentStatus>;
    lastName?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['Int']['output']>;
    metaData?: Maybe<StudentTrainingMetadata>;
    requestClientToken?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    studentNumber?: Maybe<Scalars['Int']['output']>;
    trainingId?: Maybe<Scalars['String']['output']>;
    trainingType?: Maybe<TrainingType>;
    userKey: Scalars['String']['output'];
};

export type StudentTrainingMetadata = {
    labId?: Maybe<Scalars['String']['output']>;
    labRegions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    labStatus?: Maybe<Scalars['String']['output']>;
    labUrl?: Maybe<Scalars['String']['output']>;
    preferredLangLocale: Scalars['String']['output'];
    region?: Maybe<Scalars['String']['output']>;
    targetRegions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SubProviderCapacity = {
    capacity: Scalars['Int']['output'];
    subProviderArn: Scalars['String']['output'];
    subProviderStudentCount: Scalars['Int']['output'];
};

export type SubProviderCapacityInput = {
    capacity: Scalars['Int']['input'];
    subProviderArn: Scalars['String']['input'];
};

export type SubProviderData = {
    providerArn: Scalars['String']['output'];
    providerMetaData: ProviderMetaData;
    providerName: Scalars['String']['output'];
    providerType: ProviderType;
};

export type Subscription = {
    onUpdateTrainingPermissions?: Maybe<Permission>;
};

export type Training = {
    contentId: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    duration: Scalars['Int']['output'];
    durationUnit?: Maybe<Scalars['String']['output']>;
    isActive: Scalars['Boolean']['output'];
    level?: Maybe<Scalars['Int']['output']>;
    supportedRegions: Array<Maybe<Scalars['String']['output']>>;
    title: Scalars['String']['output'];
};

export type TrainingConfiguration = {
    configuration?: Maybe<SplConfiguration>;
    contentArn: Scalars['String']['output'];
    contentType: ContentTypeEnum;
    context: Scalars['String']['output'];
};

export type TrainingType = 'JAM' | 'POOLED_SPL' | 'SPL';

export type UpdateClassroomInput = {
    addressLine1?: InputMaybe<Scalars['String']['input']>;
    addressLine2?: InputMaybe<Scalars['String']['input']>;
    city?: InputMaybe<Scalars['String']['input']>;
    classroomId: Scalars['String']['input'];
    country?: InputMaybe<Scalars['String']['input']>;
    courseId?: InputMaybe<Scalars['String']['input']>;
    endsOn?: InputMaybe<Scalars['Int']['input']>;
    langLocale?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<ClassroomLocationType>;
    postalCode?: InputMaybe<Scalars['String']['input']>;
    startsOn?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    virtualUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClassroomResult = {
    addressLine1?: Maybe<Scalars['String']['output']>;
    addressLine2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    classCapacity?: Maybe<Scalars['Int']['output']>;
    classroomArn: Scalars['String']['output'];
    classroomId: Scalars['String']['output'];
    country?: Maybe<Scalars['String']['output']>;
    courseId?: Maybe<Scalars['String']['output']>;
    endsOn?: Maybe<Scalars['Int']['output']>;
    langLocale?: Maybe<Scalars['String']['output']>;
    locationType?: Maybe<ClassroomLocationType>;
    postalCode?: Maybe<Scalars['String']['output']>;
    startsOn?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    virtualUrl?: Maybe<Scalars['String']['output']>;
};

export type UpdateClassroomV2Input = {
    accessCode?: InputMaybe<Scalars['String']['input']>;
    classCapacity?: InputMaybe<Scalars['Int']['input']>;
    classroom: ClassroomV2Input;
    classroomId: Scalars['String']['input'];
    clientRequestToken: Scalars['String']['input'];
    jamEventConfig?: InputMaybe<JamEventUpdateConfig>;
    subProviderCapacity?: InputMaybe<Array<InputMaybe<SubProviderCapacityInput>>>;
};

export type User = UserInterface & {
    emailAddress: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    licenses?: Maybe<UserLicenseNodes>;
    organizations?: Maybe<UserOrganizationNodes>;
};

export type UserIdentityAttributes = {
    email: Scalars['String']['output'];
};

export type UserInput = {
    email: Scalars['String']['input'];
};

export type UserInterface = {
    emailAddress: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastName: Scalars['String']['output'];
    licenses?: Maybe<UserLicenseNodes>;
    organizations?: Maybe<UserOrganizationNodes>;
};

export type UserLicense = {
    id?: Maybe<Scalars['ID']['output']>;
    licenseType?: Maybe<LicenseType>;
    productModality?: Maybe<ProductModality>;
};

export type UserLicenseNodes = {
    nodes?: Maybe<Array<Maybe<UserLicense>>>;
};

export type UserOrganization = {
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    sfdcAccountId?: Maybe<Scalars['String']['output']>;
};

export type UserOrganizationNodes = {
    nodes?: Maybe<Array<Maybe<UserOrganization>>>;
};

export type UserQueryMode = 'hatID' | 'userServiceID';

export type UserQueryOptionsInput = {
    fetchLicenses?: InputMaybe<Scalars['Boolean']['input']>;
    fetchOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetClassroomWithInstructorsQueryVariables = Exact<{
    classroomId: Scalars['String']['input'];
    providerArn: Scalars['String']['input'];
    withStudentRoster: Scalars['Boolean']['input'];
    withSubProviderCapacity: Scalars['Boolean']['input'];
}>;

export type GetClassroomWithInstructorsQuery = {
    listClassroomRelationships: {
        classroomUsers: Array<{ email?: string | null | undefined } | null | undefined>;
    };
    studentRoster?: {
        classroomUsers: Array<
            | {
                  email?: string | null | undefined;
                  firstName?: string | null | undefined;
                  lastName?: string | null | undefined;
                  hasAcceptedInvitation?: boolean | null | undefined;
                  userKey?: string | null | undefined;
                  eKitLicensedProviderArn?: string | null | undefined;
              }
            | null
            | undefined
        >;
    };
    getClassroom: {
        classroom: {
            accessType?: AccessType | null | undefined;
            classroomId: string;
            classroomArn: string;
            langLocale: string;
            courseId: string;
            providerArn?: string | null | undefined;
            courseTitle?: string | null | undefined;
            courseAbstract?: string | null | undefined;
            courseDescription?: string | null | undefined;
            courseLevel?: number | null | undefined;
            startsOn: number;
            endsOn: number;
            isCancellable?: boolean | null | undefined;
            learningActivityID?: string | null | undefined;
            classCapacity?: number | null | undefined;
            studentCount?: number | null | undefined;
            supportedRegions?: Array<string | null | undefined> | null | undefined;
            createdBy?: string | null | undefined;
            locationData?:
                | {
                      timezone: string;
                      locationType: ClassroomLocationType;
                      virtualUrl?: string | null | undefined;
                      source?: LocationSource | null | undefined;
                      physicalAddress?:
                          | {
                                addressLine1: string;
                                addressLine2?: string | null | undefined;
                                city: string;
                                state: string;
                                postalCode: string;
                                country: string;
                            }
                          | null
                          | undefined;
                  }
                | null
                | undefined;
            studentGuide?: { custom_vbid?: string | null | undefined } | null | undefined;
            callsToAction?:
                | Array<
                      | {
                            locationType: LocationType;
                            url?: string | null | undefined;
                            label: string;
                            actionType: CallToActionType;
                            icon?: string | null | undefined;
                            iconPosition?: CallToActionIconPosition | null | undefined;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
            accessCodes?:
                | Array<
                      | {
                            accessCode: string;
                            accessCodeCapacity: number;
                            accessCodeCapacityUsed: number;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
            subProviderCapacity?:
                | Array<
                      | {
                            subProviderArn: string;
                            capacity: number;
                            subProviderStudentCount: number;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
        };
        course: {
            courseId: string;
            title: string;
            description?: string | null | undefined;
            langLocale: string;
            abstract?: string | null | undefined;
            level?: number | null | undefined;
        };
        content: Array<
            | {
                  contentId: string;
                  title: string;
                  description?: string | null | undefined;
                  level?: number | null | undefined;
                  duration: number;
                  durationUnit?: string | null | undefined;
                  isActive: boolean;
                  supportedRegions: Array<string | null | undefined>;
              }
            | null
            | undefined
        >;
        jamTrainings?:
            | {
                  nextToken?: string | null | undefined;
                  trainings?:
                      | Array<
                            | {
                                  context: string;
                                  trainingId: string;
                                  trainingType: string;
                                  contentId: string;
                                  isActive: boolean;
                                  requestClientToken: string;
                                  fulfillmentStatus?:
                                      | JamTrainingFulfillmentStatus
                                      | null
                                      | undefined;
                                  created?: number | null | undefined;
                                  lastUpdate?: number | null | undefined;
                                  fulfillmentError?:
                                      | {
                                            message?: string | null | undefined;
                                            code?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                  metaData?:
                                      | {
                                            eventId?: string | null | undefined;
                                            eventCode?: string | null | undefined;
                                            eventStatus?: JamEventStatus | null | undefined;
                                            testCloneEventId?: string | null | undefined;
                                            testCloneEventCode?: string | null | undefined;
                                            testCloneEventSuffix?: string | null | undefined;
                                            startsOn?: number | null | undefined;
                                            endsOn?: number | null | undefined;
                                            timezone?: string | null | undefined;
                                            maxTeamSize?: number | null | undefined;
                                            maxExpectedParticipants?: number | null | undefined;
                                            eventURL?: string | null | undefined;
                                            testEventURL?: string | null | undefined;
                                            adminEventURL?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined
                        >
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export type QueryLearningActivityQueryVariables = Exact<{
    input: GetLearningActivityInput;
}>;

export type QueryLearningActivityQuery = {
    getLearningActivity: {
        pk?: string | null | undefined;
        activity_status?: string | null | undefined;
        lms_type?: string | null | undefined;
        attendedCounter?: number | null | undefined;
        instructor_notes?:
            | Array<{
                  description?: string | null | undefined;
                  timestamp?: number | null | undefined;
                  updated_by?: string | null | undefined;
              }>
            | null
            | undefined;
        delivery_sessions?:
            | Array<
                  | {
                        id?: string | null | undefined;
                        start_timestamp?: number | null | undefined;
                        end_timestamp?: number | null | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        customers?:
            | Array<
                  | {
                        customer_name?: string | null | undefined;
                        training_briefing?:
                            | {
                                  what_the_customer_does?: string | null | undefined;
                                  where_are_they_in_their_cloud_journey?: string | null | undefined;
                                  motivations_for_using_aws?: string | null | undefined;
                                  special_needs_for_training_delivery?: string | null | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        csat?:
            | { overall_score: number; instructor_score: number; completed_responses: number }
            | null
            | undefined;
    };
};

export type QueryClassAttendanceQueryVariables = Exact<{
    input: GetClassAttendanceInput;
}>;

export type QueryClassAttendanceQuery = {
    getClassAttendance: {
        learningActivityAttendanceRecords: Array<
            | {
                  learningActivityAttendanceStatus: AttendanceStatus;
                  learner: {
                      id: string;
                      emailAddress: string;
                      firstName: string;
                      lastName: string;
                  };
                  deliverySessionAttendanceRecords: Array<
                      | {
                            id: string;
                            attendanceStatus: AttendanceStatus;
                            attendanceDurationPercentage?: number | null | undefined;
                            amsDeliverySession: {
                                id: string;
                                startTime?: number | null | undefined;
                            };
                        }
                      | null
                      | undefined
                  >;
              }
            | null
            | undefined
        >;
    };
};

export type ClientLogMutationVariables = Exact<{
    input: Event;
}>;

export type ClientLogMutation = {
    clientLog: { __typename: 'StatusCode'; statusCode?: number | null | undefined };
};

export type UpdateTrainingPermissionsMutationVariables = Exact<{
    input: PermissionInput;
}>;

export type UpdateTrainingPermissionsMutation = {
    updateTrainingPermissions: {
        __typename: 'Permission';
        classroomId: string;
        providerArn?: string | null | undefined;
        activeTrainings?: Array<string> | null | undefined;
        status: string;
    };
};

export type CreateClassroomMutationVariables = Exact<{
    input: CreateClassroomInput;
}>;

export type CreateClassroomMutation = {
    createClassroom: {
        __typename: 'CreateClassroomResult';
        classroomId: string;
        classroomArn: string;
    };
};

export type CreateClassroomV2MutationVariables = Exact<{
    input: CreateClassroomV2Input;
}>;

export type CreateClassroomV2Mutation = {
    createClassroomV2: {
        __typename: 'CreateClassroomResult';
        classroomId: string;
        classroomArn: string;
    };
};

export type UpdateClassroomMutationVariables = Exact<{
    input: UpdateClassroomInput;
}>;

export type UpdateClassroomMutation = {
    updateClassroom: {
        __typename: 'UpdateClassroomResult';
        classroomId: string;
        classroomArn: string;
        langLocale?: string | null | undefined;
        courseId?: string | null | undefined;
        startsOn?: number | null | undefined;
        endsOn?: number | null | undefined;
        timezone?: string | null | undefined;
        locationType?: ClassroomLocationType | null | undefined;
        virtualUrl?: string | null | undefined;
        addressLine1?: string | null | undefined;
        addressLine2?: string | null | undefined;
        city?: string | null | undefined;
        state?: string | null | undefined;
        country?: string | null | undefined;
        postalCode?: string | null | undefined;
        classCapacity?: number | null | undefined;
    };
};

export type UpdateClassroomV2MutationVariables = Exact<{
    input: UpdateClassroomV2Input;
}>;

export type UpdateClassroomV2Mutation = {
    updateClassroomV2: {
        __typename: 'UpdateClassroomResult';
        classroomId: string;
        classroomArn: string;
        langLocale?: string | null | undefined;
        courseId?: string | null | undefined;
        startsOn?: number | null | undefined;
        endsOn?: number | null | undefined;
        timezone?: string | null | undefined;
        locationType?: ClassroomLocationType | null | undefined;
        virtualUrl?: string | null | undefined;
        addressLine1?: string | null | undefined;
        addressLine2?: string | null | undefined;
        city?: string | null | undefined;
        state?: string | null | undefined;
        country?: string | null | undefined;
        postalCode?: string | null | undefined;
        classCapacity?: number | null | undefined;
    };
};

export type CancelClassroomMutationVariables = Exact<{
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelClassroomMutation = {
    cancelClassroom: {
        __typename: 'ClassroomV2';
        classroomArn?: string | null | undefined;
        providerArn: string;
        langLocale: string;
        courseId: string;
        startsOn: number;
        endsOn: number;
        courseTitle?: string | null | undefined;
        createdByEmail?: string | null | undefined;
        instructorEmails?: Array<string | null | undefined> | null | undefined;
        locationData: {
            __typename: 'Location';
            timezone: string;
            locationType: ClassroomLocationType;
            virtualUrl?: string | null | undefined;
            source?: LocationSource | null | undefined;
            physicalAddress?:
                | {
                      __typename: 'PhysicalAddress';
                      addressLine1: string;
                      addressLine2?: string | null | undefined;
                      city: string;
                      state: string;
                      postalCode: string;
                      country: string;
                  }
                | null
                | undefined;
        };
    };
};

export type AcceptInvitationsMutationVariables = Exact<{ [key: string]: never }>;

export type AcceptInvitationsMutation = {
    acceptInvitations: {
        __typename: 'AcceptInvitationsResult';
        acceptedInvitations?:
            | Array<
                  | {
                        __typename: 'Invitation';
                        email: string;
                        invitationArn: string;
                        relationship: string;
                        resourceArn: string;
                        status: string;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type CreateClassroomRelationshipsMutationVariables = Exact<{
    input: CreateClassroomRelationshipsInput;
}>;

export type CreateClassroomRelationshipsMutation = {
    createClassroomRelationships: {
        __typename: 'StatusCode';
        statusCode?: number | null | undefined;
    };
};

export type AddStudentsToClassroomRosterMutationVariables = Exact<{
    input: AddStudentsToClassroomRosterInput;
}>;

export type AddStudentsToClassroomRosterMutation = {
    addStudentsToClassroomRoster: {
        __typename: 'StatusCode';
        statusCode?: number | null | undefined;
    };
};

export type CreateStudentTrainingsMutationVariables = Exact<{
    input: CreateStudentTrainingsInput;
}>;

export type CreateStudentTrainingsMutation = {
    createStudentTrainings: {
        __typename: 'CreateStudentTrainingsResult';
        batchId?: string | null | undefined;
        created?: number | null | undefined;
        labPoolBatchInfo?:
            | { __typename: 'LabPoolBatchInfo'; batchId: string; createdTime: number }
            | null
            | undefined;
    };
};

export type ExcludeUserMutationVariables = Exact<{
    input: ExcludeUserInput;
}>;

export type ExcludeUserMutation = {
    excludeUser: {
        __typename: 'Invitation';
        email: string;
        invitationArn: string;
        relationship: string;
        resourceArn: string;
        status: string;
    };
};

export type CancelStudentTrainingsMutationVariables = Exact<{
    input: CancelStudentTrainingsInput;
}>;

export type CancelStudentTrainingsMutation = {
    cancelStudentTrainings: {
        __typename: 'CancelStudentTrainingsResult';
        batchId: string;
        created: number;
    };
};

export type PutTrainingConfigurationMutationVariables = Exact<{
    input: PutTrainingConfigurationInput;
}>;

export type PutTrainingConfigurationMutation = {
    putTrainingConfiguration: { __typename: 'StatusCode'; statusCode?: number | null | undefined };
};

export type ResetResourcesMutationVariables = Exact<{ [key: string]: never }>;

export type ResetResourcesMutation = {
    resetResources: { __typename: 'StatusCode'; statusCode?: number | null | undefined };
};

export type MarkAttendanceMutationVariables = Exact<{
    input: MarkAttendanceInput;
}>;

export type MarkAttendanceMutation = {
    markAttendance: {
        __typename: 'MarkAttendanceResult';
        attendanceRecords: Array<
            | {
                  __typename: 'AttendanceRecord';
                  id: string;
                  version: number;
                  attendanceStatus: AttendanceStatus;
                  attendanceDurationPercentage?: number | null | undefined;
                  learner?:
                      | {
                            __typename: 'User';
                            id: string;
                            emailAddress: string;
                            firstName: string;
                            lastName: string;
                            licenses?:
                                | {
                                      __typename: 'UserLicenseNodes';
                                      nodes?:
                                          | Array<
                                                | {
                                                      __typename: 'UserLicense';
                                                      id?: string | null | undefined;
                                                      productModality?:
                                                          | ProductModality
                                                          | null
                                                          | undefined;
                                                      licenseType?: LicenseType | null | undefined;
                                                  }
                                                | null
                                                | undefined
                                            >
                                          | null
                                          | undefined;
                                  }
                                | null
                                | undefined;
                            organizations?:
                                | {
                                      __typename: 'UserOrganizationNodes';
                                      nodes?:
                                          | Array<
                                                | {
                                                      __typename: 'UserOrganization';
                                                      id?: string | null | undefined;
                                                      name?: string | null | undefined;
                                                      sfdcAccountId?: string | null | undefined;
                                                  }
                                                | null
                                                | undefined
                                            >
                                          | null
                                          | undefined;
                                  }
                                | null
                                | undefined;
                        }
                      | null
                      | undefined;
                  amsDeliverySession: {
                      __typename: 'AmsDeliverySession';
                      id: string;
                      startTime?: number | null | undefined;
                      endTime?: number | null | undefined;
                      learningActivity?:
                          | {
                                __typename: 'LearningActivity';
                                pk?: string | null | undefined;
                                attendedCounter?: number | null | undefined;
                                activity_audience?: string | null | undefined;
                                activity_modality?: string | null | undefined;
                                activity_name?: string | null | undefined;
                                activity_status?: string | null | undefined;
                                activity_type?: string | null | undefined;
                                class_size?: number | null | undefined;
                                course_name?: string | null | undefined;
                                delivery_address_1?: string | null | undefined;
                                delivery_address_2?: string | null | undefined;
                                delivery_city?: string | null | undefined;
                                delivery_country?: string | null | undefined;
                                delivery_geo?: string | null | undefined;
                                delivery_language?: string | null | undefined;
                                delivery_postal_code?: string | null | undefined;
                                delivery_region?: string | null | undefined;
                                delivery_state?: string | null | undefined;
                                delivery_timezone?: string | null | undefined;
                                program?: string | null | undefined;
                                record_type?: string | null | undefined;
                                classrooms_student_url?: string | null | undefined;
                                classrooms_arn?: string | null | undefined;
                                lms_type?: string | null | undefined;
                                v_ilt_type?: string | null | undefined;
                                v_ilt_id?: string | null | undefined;
                                v_ilt_meeting_id?: string | null | undefined;
                                registrationCounter?: number | null | undefined;
                                customers?:
                                    | Array<
                                          | {
                                                __typename: 'Customer';
                                                customer_name?: string | null | undefined;
                                                sfdc_account_id?: string | null | undefined;
                                                training_briefing?:
                                                    | {
                                                          __typename: 'CustomerTrainingBriefing';
                                                          what_the_customer_does?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          where_are_they_in_their_cloud_journey?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          motivations_for_using_aws?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                          special_needs_for_training_delivery?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                      }
                                                    | null
                                                    | undefined;
                                            }
                                          | null
                                          | undefined
                                      >
                                    | null
                                    | undefined;
                                delivery_sessions?:
                                    | Array<
                                          | {
                                                __typename: 'DeliverySession';
                                                id?: string | null | undefined;
                                                start_timestamp?: number | null | undefined;
                                                end_timestamp?: number | null | undefined;
                                            }
                                          | null
                                          | undefined
                                      >
                                    | null
                                    | undefined;
                                instructors?:
                                    | Array<
                                          | {
                                                __typename: 'Instructor';
                                                role?: string | null | undefined;
                                                pk?: string | null | undefined;
                                                type?: string | null | undefined;
                                                email?: string | null | undefined;
                                            }
                                          | null
                                          | undefined
                                      >
                                    | null
                                    | undefined;
                                instructor_notes?:
                                    | Array<{
                                          __typename: 'ActivityNote';
                                          description?: string | null | undefined;
                                          timestamp?: number | null | undefined;
                                          updated_by?: string | null | undefined;
                                      }>
                                    | null
                                    | undefined;
                                csat?:
                                    | {
                                          __typename: 'CSAT';
                                          overall_score: number;
                                          instructor_score: number;
                                          completed_responses: number;
                                      }
                                    | null
                                    | undefined;
                            }
                          | null
                          | undefined;
                  };
              }
            | null
            | undefined
        >;
    };
};

export type GetClassroomQueryVariables = Exact<{
    classroomId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetClassroomQuery = {
    getClassroom: {
        __typename: 'GetClassroomResult';
        classroom: {
            __typename: 'Classroom';
            classroomId: string;
            classroomArn: string;
            langLocale: string;
            courseId: string;
            providerArn?: string | null | undefined;
            courseTitle?: string | null | undefined;
            courseAbstract?: string | null | undefined;
            courseDescription?: string | null | undefined;
            courseLevel?: number | null | undefined;
            startsOn: number;
            endsOn: number;
            classCapacity?: number | null | undefined;
            studentCount?: number | null | undefined;
            supportedRegions?: Array<string | null | undefined> | null | undefined;
            createdBy?: string | null | undefined;
            accessType?: AccessType | null | undefined;
            isCancellable?: boolean | null | undefined;
            learningActivityID?: string | null | undefined;
            locationData?:
                | {
                      __typename: 'Location';
                      timezone: string;
                      locationType: ClassroomLocationType;
                      virtualUrl?: string | null | undefined;
                      source?: LocationSource | null | undefined;
                      physicalAddress?:
                          | {
                                __typename: 'PhysicalAddress';
                                addressLine1: string;
                                addressLine2?: string | null | undefined;
                                city: string;
                                state: string;
                                postalCode: string;
                                country: string;
                            }
                          | null
                          | undefined;
                  }
                | null
                | undefined;
            studentGuide?:
                | { __typename: 'StudentGuide'; custom_vbid?: string | null | undefined }
                | null
                | undefined;
            callsToAction?:
                | Array<
                      | {
                            __typename: 'CallsToAction';
                            locationType: LocationType;
                            url?: string | null | undefined;
                            label: string;
                            actionType: CallToActionType;
                            icon?: string | null | undefined;
                            iconPosition?: CallToActionIconPosition | null | undefined;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
            accessCodes?:
                | Array<
                      | {
                            __typename: 'AccessCode';
                            accessCode: string;
                            accessCodeCapacity: number;
                            accessCodeCapacityUsed: number;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
            subProviderCapacity?:
                | Array<
                      | {
                            __typename: 'SubProviderCapacity';
                            subProviderArn: string;
                            capacity: number;
                            subProviderStudentCount: number;
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
        };
        course: {
            __typename: 'Course';
            courseId: string;
            title: string;
            description?: string | null | undefined;
            langLocale: string;
            abstract?: string | null | undefined;
            level?: number | null | undefined;
        };
        content: Array<
            | {
                  __typename: 'Training';
                  contentId: string;
                  title: string;
                  description?: string | null | undefined;
                  level?: number | null | undefined;
                  duration: number;
                  durationUnit?: string | null | undefined;
                  isActive: boolean;
                  supportedRegions: Array<string | null | undefined>;
              }
            | null
            | undefined
        >;
        jamTrainings?:
            | {
                  __typename: 'JamTrainings';
                  nextToken?: string | null | undefined;
                  trainings?:
                      | Array<
                            | {
                                  __typename: 'JamTrainingRecord';
                                  context: string;
                                  trainingId: string;
                                  trainingType: string;
                                  contentId: string;
                                  requestClientToken: string;
                                  isActive: boolean;
                                  fulfillmentStatus?:
                                      | JamTrainingFulfillmentStatus
                                      | null
                                      | undefined;
                                  created?: number | null | undefined;
                                  lastUpdate?: number | null | undefined;
                                  fulfillmentError?:
                                      | {
                                            __typename: 'JamFulFillmentError';
                                            message?: string | null | undefined;
                                            code?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                                  metaData?:
                                      | {
                                            __typename: 'JamMetaData';
                                            eventId?: string | null | undefined;
                                            eventCode?: string | null | undefined;
                                            eventStatus?: JamEventStatus | null | undefined;
                                            testCloneEventId?: string | null | undefined;
                                            testCloneEventCode?: string | null | undefined;
                                            testCloneEventSuffix?: string | null | undefined;
                                            startsOn?: number | null | undefined;
                                            endsOn?: number | null | undefined;
                                            timezone?: string | null | undefined;
                                            maxTeamSize?: number | null | undefined;
                                            maxExpectedParticipants?: number | null | undefined;
                                            eventURL?: string | null | undefined;
                                            testEventURL?: string | null | undefined;
                                            adminEventURL?: string | null | undefined;
                                        }
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined
                        >
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export type GetStudentTrainingsByClassroomIdQueryVariables = Exact<{
    classroomId: Scalars['String']['input'];
    accessType?: InputMaybe<AccessType>;
    providerArn?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetStudentTrainingsByClassroomIdQuery = {
    getStudentTrainingsByClassroomId: {
        __typename: 'GetStudentTrainingsByClassroomId';
        studentTrainings: Array<
            | {
                  __typename: 'StudentTraining';
                  lastUpdated?: number | null | undefined;
                  trainingId?: string | null | undefined;
                  context: string;
                  created?: number | null | undefined;
                  requestClientToken?: string | null | undefined;
                  arn?: string | null | undefined;
                  state?: string | null | undefined;
                  fulfillmentStatus?: FulfillmentStatus | null | undefined;
                  bunsenLabStatus?: string | null | undefined;
                  userKey: string;
                  studentNumber?: number | null | undefined;
                  firstName?: string | null | undefined;
                  lastName?: string | null | undefined;
                  email?: string | null | undefined;
                  trainingType?: TrainingType | null | undefined;
                  metaData?:
                      | {
                            __typename: 'StudentTrainingMetadata';
                            preferredLangLocale: string;
                            labId?: string | null | undefined;
                            labUrl?: string | null | undefined;
                            labStatus?: string | null | undefined;
                            region?: string | null | undefined;
                            labRegions?: Array<string | null | undefined> | null | undefined;
                            targetRegions?: Array<string | null | undefined> | null | undefined;
                        }
                      | null
                      | undefined;
                  fulfillmentError?:
                      | {
                            __typename: 'FulFillmentError';
                            message?: string | null | undefined;
                            name?: string | null | undefined;
                        }
                      | null
                      | undefined;
              }
            | null
            | undefined
        >;
    };
};

export type GetIngressUrlQueryVariables = Exact<{
    input: GetIngressUrlInput;
}>;

export type GetIngressUrlQuery = {
    getIngressUrl: {
        __typename: 'GetIngressUrlResult';
        labId: string;
        consoleUrl: string;
        endsOn: number;
        status: string;
    };
};

export type GetCourseVersionsQueryVariables = Exact<{
    input: GetCourseVersionsInput;
}>;

export type GetCourseVersionsQuery = {
    getCourseVersions: {
        __typename: 'GetCourseVersionsResult';
        nextToken?: string | null | undefined;
        courseVersions?:
            | Array<
                  | {
                        __typename: 'CourseVersionListItem';
                        courseId: string;
                        versionId: string;
                        createdOn: number;
                        status: ContentStatus;
                        availability: ContentAvailability;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type GetCourseVersionQueryVariables = Exact<{
    courseVersionId: Scalars['String']['input'];
    providerArn?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCourseVersionQuery = {
    getCourseVersion: {
        __typename: 'GetCourseVersionResult';
        courseVersion?:
            | {
                  __typename: 'CourseVersion';
                  courseVersionId: string;
                  createdOn: number;
                  availability: ContentAvailability;
                  status: ContentStatus;
                  courseName: string;
                  supportedLocales: Array<string | null | undefined>;
                  contentVersion?: string | null | undefined;
                  contentTypes?: Array<ContentType | null | undefined> | null | undefined;
                  blueprintData?:
                      | Array<
                            | { __typename: 'BlueprintData'; blueprintName: string; arn: string }
                            | null
                            | undefined
                        >
                      | null
                      | undefined;
                  resourceData?:
                      | Array<
                            | {
                                  __typename: 'CourseResourceData';
                                  locale: string;
                                  description?: string | null | undefined;
                                  title?: string | null | undefined;
                              }
                            | null
                            | undefined
                        >
                      | null
                      | undefined;
                  jamConfig?:
                      | { __typename: 'JamConfig'; challengeSetID: string }
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export type GetProviderArnsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProviderArnsQuery = {
    getProviderArns: {
        __typename: 'GetProviderArnsResult';
        providers?: Array<string | null | undefined> | null | undefined;
    };
};

export type GetProviderQueryVariables = Exact<{
    input: GetProviderInput;
}>;

export type GetProviderQuery = {
    getProvider: {
        __typename: 'GetProviderResult';
        provider: {
            __typename: 'Provider';
            name: string;
            arn: string;
            type: ProviderType;
            subProviderData?:
                | Array<
                      | {
                            __typename: 'SubProviderData';
                            providerName: string;
                            providerType: ProviderType;
                            providerArn: string;
                            providerMetaData: {
                                __typename: 'ProviderMetaData';
                                isParentProvider: boolean;
                                parentProviderArn: string;
                            };
                        }
                      | null
                      | undefined
                  >
                | null
                | undefined;
        };
    };
};

export type GetServiceScheduleQueryVariables = Exact<{
    input: GetServiceScheduleInput;
}>;

export type GetServiceScheduleQuery = {
    getServiceSchedule: {
        __typename: 'GetServiceScheduleResult';
        schedules: Array<
            | {
                  __typename: 'GetServiceSchedule';
                  service: string;
                  domain: string;
                  endTime: number;
                  startTime: number;
                  event: EventReason;
                  type: EventType;
              }
            | null
            | undefined
        >;
    };
};

export type GetProviderReportQueryVariables = Exact<{
    input: GetProviderReportInput;
}>;

export type GetProviderReportQuery = {
    getProviderReport: {
        __typename: 'GetProviderReportResult';
        presignedUrl?: string | null | undefined;
    };
};

export type GetTrainingConfigurationQueryVariables = Exact<{
    input: GetTrainingConfigurationInput;
}>;

export type GetTrainingConfigurationQuery = {
    getTrainingConfiguration: {
        __typename: 'TrainingConfiguration';
        context: string;
        contentArn: string;
        contentType: ContentTypeEnum;
        configuration?:
            | {
                  __typename: 'SplConfiguration';
                  targetRegions?: Array<string | null | undefined> | null | undefined;
              }
            | null
            | undefined;
    };
};

export type ListUserRelationshipsQueryVariables = Exact<{
    input: ListUserRelationshipsInput;
}>;

export type ListUserRelationshipsQuery = {
    listUserRelationships: {
        __typename: 'ListUserRelationshipsResult';
        relationships?: Array<string | null | undefined> | null | undefined;
    };
};

export type ListClassroomRelationshipsQueryVariables = Exact<{
    input: ListClassroomRelationshipsInput;
}>;

export type ListClassroomRelationshipsQuery = {
    listClassroomRelationships: {
        __typename: 'ListClassroomRelationshipsResult';
        emails?: Array<string | null | undefined> | null | undefined;
        classroomUsers: Array<
            | {
                  __typename: 'ClassroomUser';
                  email?: string | null | undefined;
                  userKey?: string | null | undefined;
                  firstName?: string | null | undefined;
                  lastName?: string | null | undefined;
                  hasAcceptedInvitation?: boolean | null | undefined;
                  eKitLicensedProviderArn?: string | null | undefined;
              }
            | null
            | undefined
        >;
    };
};

export type ListUserClassroomsQueryVariables = Exact<{
    input: ListClassroomsInput;
}>;

export type ListUserClassroomsQuery = {
    listUserClassrooms: {
        __typename: 'ListClassroomsResult';
        nextToken?: string | null | undefined;
        classrooms?:
            | Array<
                  | {
                        __typename: 'ClassroomV2';
                        classroomArn?: string | null | undefined;
                        providerArn: string;
                        langLocale: string;
                        courseId: string;
                        startsOn: number;
                        endsOn: number;
                        courseTitle?: string | null | undefined;
                        createdByEmail?: string | null | undefined;
                        instructorEmails?: Array<string | null | undefined> | null | undefined;
                        locationData: {
                            __typename: 'Location';
                            timezone: string;
                            locationType: ClassroomLocationType;
                            virtualUrl?: string | null | undefined;
                            source?: LocationSource | null | undefined;
                            physicalAddress?:
                                | {
                                      __typename: 'PhysicalAddress';
                                      addressLine1: string;
                                      addressLine2?: string | null | undefined;
                                      city: string;
                                      state: string;
                                      postalCode: string;
                                      country: string;
                                  }
                                | null
                                | undefined;
                        };
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type ListProviderClassroomsQueryVariables = Exact<{
    input: ListClassroomsInput;
}>;

export type ListProviderClassroomsQuery = {
    listProviderClassrooms: {
        __typename: 'ListClassroomsResult';
        nextToken?: string | null | undefined;
        classrooms?:
            | Array<
                  | {
                        __typename: 'ClassroomV2';
                        classroomArn?: string | null | undefined;
                        providerArn: string;
                        langLocale: string;
                        courseId: string;
                        startsOn: number;
                        endsOn: number;
                        courseTitle?: string | null | undefined;
                        createdByEmail?: string | null | undefined;
                        instructorEmails?: Array<string | null | undefined> | null | undefined;
                        locationData: {
                            __typename: 'Location';
                            timezone: string;
                            locationType: ClassroomLocationType;
                            virtualUrl?: string | null | undefined;
                            source?: LocationSource | null | undefined;
                            physicalAddress?:
                                | {
                                      __typename: 'PhysicalAddress';
                                      addressLine1: string;
                                      addressLine2?: string | null | undefined;
                                      city: string;
                                      state: string;
                                      postalCode: string;
                                      country: string;
                                  }
                                | null
                                | undefined;
                        };
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type ListProviderReportsQueryVariables = Exact<{
    input: ListProviderReportsInput;
}>;

export type ListProviderReportsQuery = {
    listProviderReports: {
        __typename: 'ListProviderReportsResult';
        nextToken?: string | null | undefined;
        iltReports?:
            | Array<
                  | {
                        __typename: 'ProviderReport';
                        reportId?: string | null | undefined;
                        reportName: string;
                        reportDate: string;
                        reportDescription: string;
                        createdDate: string;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type ListCoursesQueryVariables = Exact<{
    input: ListCoursesInput;
}>;

export type ListCoursesQuery = {
    listCourses: {
        __typename: 'ListCoursesResult';
        courses: Array<
            { __typename: 'GrimsbyCourse'; title: string; id: string } | null | undefined
        >;
    };
};

export type ListMajorCourseVersionsQueryVariables = Exact<{
    input?: InputMaybe<ListMajorCourseVersionsInput>;
}>;

export type ListMajorCourseVersionsQuery = {
    listMajorCourseVersions: {
        __typename: 'ListMajorCourseVersionsResult';
        nextToken?: string | null | undefined;
        collections: Array<
            | {
                  __typename: 'Collection';
                  collectionArn: string;
                  collectionTitle: string;
                  supportedLangLocales?: Array<string | null | undefined> | null | undefined;
                  courseTemplatePk?: string | null | undefined;
              }
            | null
            | undefined
        >;
    };
};

export type ListInstructorClassroomsV2QueryVariables = Exact<{
    input: ListInstructorClassroomsV2Input;
}>;

export type ListInstructorClassroomsV2Query = {
    listInstructorClassroomsV2: {
        __typename: 'ListClassroomsV2Result';
        count?: number | null | undefined;
        countType?: CountType | null | undefined;
        classrooms?:
            | Array<
                  | {
                        __typename: 'ClassroomV2';
                        classroomArn?: string | null | undefined;
                        providerArn: string;
                        langLocale: string;
                        courseId: string;
                        startsOn: number;
                        endsOn: number;
                        courseTitle?: string | null | undefined;
                        createdByEmail?: string | null | undefined;
                        instructorEmails?: Array<string | null | undefined> | null | undefined;
                        locationData: {
                            __typename: 'Location';
                            timezone: string;
                            locationType: ClassroomLocationType;
                            virtualUrl?: string | null | undefined;
                            source?: LocationSource | null | undefined;
                            physicalAddress?:
                                | {
                                      __typename: 'PhysicalAddress';
                                      addressLine1: string;
                                      addressLine2?: string | null | undefined;
                                      city: string;
                                      state: string;
                                      postalCode: string;
                                      country: string;
                                  }
                                | null
                                | undefined;
                        };
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        aggregations?:
            | {
                  __typename: 'ClassroomListAggregations';
                  courseTitle?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
                  langLocale?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
                  country?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export type ListProviderClassroomsV2QueryVariables = Exact<{
    input: ListProviderClassroomsV2Input;
}>;

export type ListProviderClassroomsV2Query = {
    listProviderClassroomsV2: {
        __typename: 'ListClassroomsV2Result';
        count?: number | null | undefined;
        countType?: CountType | null | undefined;
        classrooms?:
            | Array<
                  | {
                        __typename: 'ClassroomV2';
                        classroomArn?: string | null | undefined;
                        providerArn: string;
                        langLocale: string;
                        courseId: string;
                        startsOn: number;
                        endsOn: number;
                        courseTitle?: string | null | undefined;
                        createdByEmail?: string | null | undefined;
                        instructorEmails?: Array<string | null | undefined> | null | undefined;
                        locationData: {
                            __typename: 'Location';
                            timezone: string;
                            locationType: ClassroomLocationType;
                            virtualUrl?: string | null | undefined;
                            source?: LocationSource | null | undefined;
                            physicalAddress?:
                                | {
                                      __typename: 'PhysicalAddress';
                                      addressLine1: string;
                                      addressLine2?: string | null | undefined;
                                      city: string;
                                      state: string;
                                      postalCode: string;
                                      country: string;
                                  }
                                | null
                                | undefined;
                        };
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        aggregations?:
            | {
                  __typename: 'ClassroomListAggregations';
                  courseTitle?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
                  langLocale?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
                  country?:
                      | {
                            __typename: 'AttributeAggregation';
                            countType?: CountType | null | undefined;
                            items: Array<
                                | {
                                      __typename: 'AttributeAggregationItem';
                                      value: string;
                                      count: number;
                                  }
                                | null
                                | undefined
                            >;
                        }
                      | null
                      | undefined;
              }
            | null
            | undefined;
    };
};

export type RequiresResetQueryVariables = Exact<{ [key: string]: never }>;

export type RequiresResetQuery = {
    requiresReset: { __typename: 'RequiresResetResult'; requiresReset: boolean };
};

export type CourseVirtualSkuInfoQueryVariables = Exact<{
    input: CourseVirtualSkuInfoInput;
}>;

export type CourseVirtualSkuInfoQuery = {
    courseVirtualSKUInfo: {
        __typename: 'CourseVirtualSKUInfoResult';
        productId?: string | null | undefined;
        availableQuantity: number;
    };
};

export type GetLearningActivityQueryVariables = Exact<{
    input: GetLearningActivityInput;
}>;

export type GetLearningActivityQuery = {
    getLearningActivity: {
        __typename: 'LearningActivity';
        pk?: string | null | undefined;
        attendedCounter?: number | null | undefined;
        activity_audience?: string | null | undefined;
        activity_modality?: string | null | undefined;
        activity_name?: string | null | undefined;
        activity_status?: string | null | undefined;
        activity_type?: string | null | undefined;
        class_size?: number | null | undefined;
        course_name?: string | null | undefined;
        delivery_address_1?: string | null | undefined;
        delivery_address_2?: string | null | undefined;
        delivery_city?: string | null | undefined;
        delivery_country?: string | null | undefined;
        delivery_geo?: string | null | undefined;
        delivery_language?: string | null | undefined;
        delivery_postal_code?: string | null | undefined;
        delivery_region?: string | null | undefined;
        delivery_state?: string | null | undefined;
        delivery_timezone?: string | null | undefined;
        program?: string | null | undefined;
        record_type?: string | null | undefined;
        classrooms_student_url?: string | null | undefined;
        classrooms_arn?: string | null | undefined;
        lms_type?: string | null | undefined;
        v_ilt_type?: string | null | undefined;
        v_ilt_id?: string | null | undefined;
        v_ilt_meeting_id?: string | null | undefined;
        registrationCounter?: number | null | undefined;
        customers?:
            | Array<
                  | {
                        __typename: 'Customer';
                        customer_name?: string | null | undefined;
                        sfdc_account_id?: string | null | undefined;
                        training_briefing?:
                            | {
                                  __typename: 'CustomerTrainingBriefing';
                                  what_the_customer_does?: string | null | undefined;
                                  where_are_they_in_their_cloud_journey?: string | null | undefined;
                                  motivations_for_using_aws?: string | null | undefined;
                                  special_needs_for_training_delivery?: string | null | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        delivery_sessions?:
            | Array<
                  | {
                        __typename: 'DeliverySession';
                        id?: string | null | undefined;
                        start_timestamp?: number | null | undefined;
                        end_timestamp?: number | null | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        instructors?:
            | Array<
                  | {
                        __typename: 'Instructor';
                        role?: string | null | undefined;
                        pk?: string | null | undefined;
                        type?: string | null | undefined;
                        email?: string | null | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        instructor_notes?:
            | Array<{
                  __typename: 'ActivityNote';
                  description?: string | null | undefined;
                  timestamp?: number | null | undefined;
                  updated_by?: string | null | undefined;
              }>
            | null
            | undefined;
        csat?:
            | {
                  __typename: 'CSAT';
                  overall_score: number;
                  instructor_score: number;
                  completed_responses: number;
              }
            | null
            | undefined;
    };
};

export type GetClassAttendanceQueryVariables = Exact<{
    input: GetClassAttendanceInput;
}>;

export type GetClassAttendanceQuery = {
    getClassAttendance: {
        __typename: 'GetClassAttendanceResult';
        learningActivityAttendanceRecords: Array<
            | {
                  __typename: 'LearningActivityAttendanceRecord';
                  learningActivityAttendanceStatus: AttendanceStatus;
                  learner: {
                      __typename: 'LearningActivityUser';
                      id: string;
                      emailAddress: string;
                      firstName: string;
                      lastName: string;
                      evaluationStatus?: EvaluationStatus | null | undefined;
                      licenses?:
                          | {
                                __typename: 'UserLicenseNodes';
                                nodes?:
                                    | Array<
                                          | {
                                                __typename: 'UserLicense';
                                                id?: string | null | undefined;
                                                productModality?:
                                                    | ProductModality
                                                    | null
                                                    | undefined;
                                                licenseType?: LicenseType | null | undefined;
                                            }
                                          | null
                                          | undefined
                                      >
                                    | null
                                    | undefined;
                            }
                          | null
                          | undefined;
                      organizations?:
                          | {
                                __typename: 'UserOrganizationNodes';
                                nodes?:
                                    | Array<
                                          | {
                                                __typename: 'UserOrganization';
                                                id?: string | null | undefined;
                                                name?: string | null | undefined;
                                                sfdcAccountId?: string | null | undefined;
                                            }
                                          | null
                                          | undefined
                                      >
                                    | null
                                    | undefined;
                            }
                          | null
                          | undefined;
                  };
                  deliverySessionAttendanceRecords: Array<
                      | {
                            __typename: 'AttendanceRecord';
                            id: string;
                            version: number;
                            attendanceStatus: AttendanceStatus;
                            attendanceDurationPercentage?: number | null | undefined;
                            learner?:
                                | {
                                      __typename: 'User';
                                      id: string;
                                      emailAddress: string;
                                      firstName: string;
                                      lastName: string;
                                      licenses?:
                                          | {
                                                __typename: 'UserLicenseNodes';
                                                nodes?:
                                                    | Array<
                                                          | {
                                                                __typename: 'UserLicense';
                                                                id?: string | null | undefined;
                                                                productModality?:
                                                                    | ProductModality
                                                                    | null
                                                                    | undefined;
                                                                licenseType?:
                                                                    | LicenseType
                                                                    | null
                                                                    | undefined;
                                                            }
                                                          | null
                                                          | undefined
                                                      >
                                                    | null
                                                    | undefined;
                                            }
                                          | null
                                          | undefined;
                                      organizations?:
                                          | {
                                                __typename: 'UserOrganizationNodes';
                                                nodes?:
                                                    | Array<
                                                          | {
                                                                __typename: 'UserOrganization';
                                                                id?: string | null | undefined;
                                                                name?: string | null | undefined;
                                                                sfdcAccountId?:
                                                                    | string
                                                                    | null
                                                                    | undefined;
                                                            }
                                                          | null
                                                          | undefined
                                                      >
                                                    | null
                                                    | undefined;
                                            }
                                          | null
                                          | undefined;
                                  }
                                | null
                                | undefined;
                            amsDeliverySession: {
                                __typename: 'AmsDeliverySession';
                                id: string;
                                startTime?: number | null | undefined;
                                endTime?: number | null | undefined;
                                learningActivity?:
                                    | {
                                          __typename: 'LearningActivity';
                                          pk?: string | null | undefined;
                                          attendedCounter?: number | null | undefined;
                                          activity_audience?: string | null | undefined;
                                          activity_modality?: string | null | undefined;
                                          activity_name?: string | null | undefined;
                                          activity_status?: string | null | undefined;
                                          activity_type?: string | null | undefined;
                                          class_size?: number | null | undefined;
                                          course_name?: string | null | undefined;
                                          delivery_address_1?: string | null | undefined;
                                          delivery_address_2?: string | null | undefined;
                                          delivery_city?: string | null | undefined;
                                          delivery_country?: string | null | undefined;
                                          delivery_geo?: string | null | undefined;
                                          delivery_language?: string | null | undefined;
                                          delivery_postal_code?: string | null | undefined;
                                          delivery_region?: string | null | undefined;
                                          delivery_state?: string | null | undefined;
                                          delivery_timezone?: string | null | undefined;
                                          program?: string | null | undefined;
                                          record_type?: string | null | undefined;
                                          classrooms_student_url?: string | null | undefined;
                                          classrooms_arn?: string | null | undefined;
                                          lms_type?: string | null | undefined;
                                          v_ilt_type?: string | null | undefined;
                                          v_ilt_id?: string | null | undefined;
                                          v_ilt_meeting_id?: string | null | undefined;
                                          registrationCounter?: number | null | undefined;
                                          customers?:
                                              | Array<
                                                    | {
                                                          __typename: 'Customer';
                                                          customer_name?: string | null | undefined;
                                                          sfdc_account_id?:
                                                              | string
                                                              | null
                                                              | undefined;
                                                      }
                                                    | null
                                                    | undefined
                                                >
                                              | null
                                              | undefined;
                                          delivery_sessions?:
                                              | Array<
                                                    | {
                                                          __typename: 'DeliverySession';
                                                          id?: string | null | undefined;
                                                          start_timestamp?:
                                                              | number
                                                              | null
                                                              | undefined;
                                                          end_timestamp?: number | null | undefined;
                                                      }
                                                    | null
                                                    | undefined
                                                >
                                              | null
                                              | undefined;
                                          instructors?:
                                              | Array<
                                                    | {
                                                          __typename: 'Instructor';
                                                          role?: string | null | undefined;
                                                          pk?: string | null | undefined;
                                                          type?: string | null | undefined;
                                                          email?: string | null | undefined;
                                                      }
                                                    | null
                                                    | undefined
                                                >
                                              | null
                                              | undefined;
                                          instructor_notes?:
                                              | Array<{
                                                    __typename: 'ActivityNote';
                                                    description?: string | null | undefined;
                                                    timestamp?: number | null | undefined;
                                                    updated_by?: string | null | undefined;
                                                }>
                                              | null
                                              | undefined;
                                          csat?:
                                              | {
                                                    __typename: 'CSAT';
                                                    overall_score: number;
                                                    instructor_score: number;
                                                    completed_responses: number;
                                                }
                                              | null
                                              | undefined;
                                      }
                                    | null
                                    | undefined;
                            };
                        }
                      | null
                      | undefined
                  >;
              }
            | null
            | undefined
        >;
        pageInfo?:
            | {
                  __typename: 'PageInfo';
                  cursor?: string | null | undefined;
                  size?: number | null | undefined;
              }
            | null
            | undefined;
    };
};

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFeatureFlagsQuery = {
    getFeatureFlags?:
        | Array<{ __typename: 'FeatureFlag'; flag: string; enabled: boolean }>
        | null
        | undefined;
};

export type BatchGetUserInfoQueryVariables = Exact<{
    input: BatchGetUserInfoInput;
}>;

export type BatchGetUserInfoQuery = {
    batchGetUserInfo: {
        __typename: 'BatchGetUserInfoResult';
        users?:
            | Array<
                  | {
                        __typename: 'GetUserInfoResult';
                        id?: string | null | undefined;
                        emailAddress?: string | null | undefined;
                        firstName?: string | null | undefined;
                        lastName?: string | null | undefined;
                        licenses?:
                            | {
                                  __typename: 'UserLicenseNodes';
                                  nodes?:
                                      | Array<
                                            | {
                                                  __typename: 'UserLicense';
                                                  id?: string | null | undefined;
                                                  productModality?:
                                                      | ProductModality
                                                      | null
                                                      | undefined;
                                                  licenseType?: LicenseType | null | undefined;
                                              }
                                            | null
                                            | undefined
                                        >
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                        organizations?:
                            | {
                                  __typename: 'UserOrganizationNodes';
                                  nodes?:
                                      | Array<
                                            | {
                                                  __typename: 'UserOrganization';
                                                  id?: string | null | undefined;
                                                  name?: string | null | undefined;
                                                  sfdcAccountId?: string | null | undefined;
                                              }
                                            | null
                                            | undefined
                                        >
                                      | null
                                      | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
        failedUsers?:
            | Array<
                  | {
                        __typename: 'FailedGetUserInfoResult';
                        id?: string | null | undefined;
                        error?: string | null | undefined;
                    }
                  | null
                  | undefined
              >
            | null
            | undefined;
    };
};

export type OnUpdateTrainingPermissionsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type OnUpdateTrainingPermissionsSubscription = {
    onUpdateTrainingPermissions?:
        | {
              __typename: 'Permission';
              classroomId: string;
              providerArn?: string | null | undefined;
              activeTrainings?: Array<string> | null | undefined;
              status: string;
          }
        | null
        | undefined;
};

export const GetClassroomWithInstructorsDocument = `
    query GetClassroomWithInstructors($classroomId: String!, $providerArn: String!, $withStudentRoster: Boolean!, $withSubProviderCapacity: Boolean!) {
  listClassroomRelationships(
    input: {classroomId: $classroomId, providerArn: $providerArn, relationship: instructor}
  ) {
    classroomUsers {
      email
    }
  }
  studentRoster: listClassroomRelationships(
    input: {classroomId: $classroomId, providerArn: $providerArn, relationship: student}
  ) @include(if: $withStudentRoster) {
    classroomUsers {
      email
      firstName
      lastName
      hasAcceptedInvitation
      userKey
      eKitLicensedProviderArn
    }
  }
  getClassroom(classroomId: $classroomId, providerArn: $providerArn) {
    classroom {
      accessType
      classroomId
      classroomArn
      langLocale
      courseId
      providerArn
      courseTitle
      courseAbstract
      courseDescription
      courseLevel
      startsOn
      endsOn
      isCancellable
      learningActivityID
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
        }
        source
      }
      studentGuide {
        custom_vbid
      }
      callsToAction {
        locationType
        url
        label
        actionType
        icon
        iconPosition
      }
      accessCodes {
        accessCode
        accessCodeCapacity
        accessCodeCapacityUsed
      }
      classCapacity
      subProviderCapacity @include(if: $withSubProviderCapacity) {
        subProviderArn
        capacity
        subProviderStudentCount
      }
      studentCount
      supportedRegions
      createdBy
    }
    course {
      courseId
      title
      description
      langLocale
      abstract
      level
    }
    content {
      contentId
      title
      description
      level
      duration
      durationUnit
      isActive
      supportedRegions
    }
    jamTrainings {
      trainings {
        context
        trainingId
        trainingType
        contentId
        isActive
        requestClientToken
        fulfillmentStatus
        fulfillmentError {
          message
          code
        }
        created
        lastUpdate
        metaData {
          eventId
          eventCode
          eventStatus
          testCloneEventId
          testCloneEventCode
          testCloneEventSuffix
          startsOn
          endsOn
          timezone
          maxTeamSize
          maxExpectedParticipants
          eventURL
          testEventURL
          adminEventURL
        }
      }
      nextToken
    }
  }
}
    `;

export const useGetClassroomWithInstructorsQuery = <
    TData = GetClassroomWithInstructorsQuery,
    TError = unknown,
>(
    variables: GetClassroomWithInstructorsQueryVariables,
    options?: UseQueryOptions<GetClassroomWithInstructorsQuery, TError, TData>,
) => {
    return useQuery<GetClassroomWithInstructorsQuery, TError, TData>(
        ['GetClassroomWithInstructors', variables],
        fetchData<GetClassroomWithInstructorsQuery, GetClassroomWithInstructorsQueryVariables>(
            GetClassroomWithInstructorsDocument,
            variables,
        ),
        options,
    );
};

export const QueryLearningActivityDocument = `
    query QueryLearningActivity($input: GetLearningActivityInput!) {
  getLearningActivity(input: $input) {
    pk
    activity_status
    lms_type
    attendedCounter
    instructor_notes {
      description
      timestamp
      updated_by
    }
    delivery_sessions {
      id
      start_timestamp
      end_timestamp
    }
    customers {
      customer_name
      training_briefing {
        what_the_customer_does
        where_are_they_in_their_cloud_journey
        motivations_for_using_aws
        special_needs_for_training_delivery
      }
    }
    csat {
      overall_score
      instructor_score
      completed_responses
    }
  }
}
    `;

export const useQueryLearningActivityQuery = <TData = QueryLearningActivityQuery, TError = unknown>(
    variables: QueryLearningActivityQueryVariables,
    options?: UseQueryOptions<QueryLearningActivityQuery, TError, TData>,
) => {
    return useQuery<QueryLearningActivityQuery, TError, TData>(
        ['QueryLearningActivity', variables],
        fetchData<QueryLearningActivityQuery, QueryLearningActivityQueryVariables>(
            QueryLearningActivityDocument,
            variables,
        ),
        options,
    );
};

export const QueryClassAttendanceDocument = `
    query QueryClassAttendance($input: GetClassAttendanceInput!) {
  getClassAttendance(input: $input) {
    learningActivityAttendanceRecords {
      learner {
        id
        emailAddress
        firstName
        lastName
      }
      learningActivityAttendanceStatus
      deliverySessionAttendanceRecords {
        id
        attendanceStatus
        attendanceDurationPercentage
        amsDeliverySession {
          id
          startTime
        }
      }
    }
  }
}
    `;

export const useQueryClassAttendanceQuery = <TData = QueryClassAttendanceQuery, TError = unknown>(
    variables: QueryClassAttendanceQueryVariables,
    options?: UseQueryOptions<QueryClassAttendanceQuery, TError, TData>,
) => {
    return useQuery<QueryClassAttendanceQuery, TError, TData>(
        ['QueryClassAttendance', variables],
        fetchData<QueryClassAttendanceQuery, QueryClassAttendanceQueryVariables>(
            QueryClassAttendanceDocument,
            variables,
        ),
        options,
    );
};

export const ClientLogDocument = `
    mutation ClientLog($input: Event!) {
  clientLog(input: $input) {
    statusCode
    __typename
  }
}
    `;

export const useClientLogMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<ClientLogMutation, TError, ClientLogMutationVariables, TContext>,
) => {
    return useMutation<ClientLogMutation, TError, ClientLogMutationVariables, TContext>(
        ['ClientLog'],
        (variables?: ClientLogMutationVariables) =>
            fetchData<ClientLogMutation, ClientLogMutationVariables>(
                ClientLogDocument,
                variables,
            )(),
        options,
    );
};

export const UpdateTrainingPermissionsDocument = `
    mutation UpdateTrainingPermissions($input: PermissionInput!) {
  updateTrainingPermissions(input: $input) {
    classroomId
    providerArn
    activeTrainings
    status
    __typename
  }
}
    `;

export const useUpdateTrainingPermissionsMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        UpdateTrainingPermissionsMutation,
        TError,
        UpdateTrainingPermissionsMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        UpdateTrainingPermissionsMutation,
        TError,
        UpdateTrainingPermissionsMutationVariables,
        TContext
    >(
        ['UpdateTrainingPermissions'],
        (variables?: UpdateTrainingPermissionsMutationVariables) =>
            fetchData<
                UpdateTrainingPermissionsMutation,
                UpdateTrainingPermissionsMutationVariables
            >(UpdateTrainingPermissionsDocument, variables)(),
        options,
    );
};

export const CreateClassroomDocument = `
    mutation CreateClassroom($input: CreateClassroomInput!) {
  createClassroom(input: $input) {
    classroomId
    classroomArn
    __typename
  }
}
    `;

export const useCreateClassroomMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CreateClassroomMutation,
        TError,
        CreateClassroomMutationVariables,
        TContext
    >,
) => {
    return useMutation<CreateClassroomMutation, TError, CreateClassroomMutationVariables, TContext>(
        ['CreateClassroom'],
        (variables?: CreateClassroomMutationVariables) =>
            fetchData<CreateClassroomMutation, CreateClassroomMutationVariables>(
                CreateClassroomDocument,
                variables,
            )(),
        options,
    );
};

export const CreateClassroomV2Document = `
    mutation CreateClassroomV2($input: CreateClassroomV2Input!) {
  createClassroomV2(input: $input) {
    classroomId
    classroomArn
    __typename
  }
}
    `;

export const useCreateClassroomV2Mutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CreateClassroomV2Mutation,
        TError,
        CreateClassroomV2MutationVariables,
        TContext
    >,
) => {
    return useMutation<
        CreateClassroomV2Mutation,
        TError,
        CreateClassroomV2MutationVariables,
        TContext
    >(
        ['CreateClassroomV2'],
        (variables?: CreateClassroomV2MutationVariables) =>
            fetchData<CreateClassroomV2Mutation, CreateClassroomV2MutationVariables>(
                CreateClassroomV2Document,
                variables,
            )(),
        options,
    );
};

export const UpdateClassroomDocument = `
    mutation UpdateClassroom($input: UpdateClassroomInput!) {
  updateClassroom(input: $input) {
    classroomId
    classroomArn
    langLocale
    courseId
    startsOn
    endsOn
    timezone
    locationType
    virtualUrl
    addressLine1
    addressLine2
    city
    state
    country
    postalCode
    classCapacity
    __typename
  }
}
    `;

export const useUpdateClassroomMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        UpdateClassroomMutation,
        TError,
        UpdateClassroomMutationVariables,
        TContext
    >,
) => {
    return useMutation<UpdateClassroomMutation, TError, UpdateClassroomMutationVariables, TContext>(
        ['UpdateClassroom'],
        (variables?: UpdateClassroomMutationVariables) =>
            fetchData<UpdateClassroomMutation, UpdateClassroomMutationVariables>(
                UpdateClassroomDocument,
                variables,
            )(),
        options,
    );
};

export const UpdateClassroomV2Document = `
    mutation UpdateClassroomV2($input: UpdateClassroomV2Input!) {
  updateClassroomV2(input: $input) {
    classroomId
    classroomArn
    langLocale
    courseId
    startsOn
    endsOn
    timezone
    locationType
    virtualUrl
    addressLine1
    addressLine2
    city
    state
    country
    postalCode
    classCapacity
    __typename
  }
}
    `;

export const useUpdateClassroomV2Mutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        UpdateClassroomV2Mutation,
        TError,
        UpdateClassroomV2MutationVariables,
        TContext
    >,
) => {
    return useMutation<
        UpdateClassroomV2Mutation,
        TError,
        UpdateClassroomV2MutationVariables,
        TContext
    >(
        ['UpdateClassroomV2'],
        (variables?: UpdateClassroomV2MutationVariables) =>
            fetchData<UpdateClassroomV2Mutation, UpdateClassroomV2MutationVariables>(
                UpdateClassroomV2Document,
                variables,
            )(),
        options,
    );
};

export const CancelClassroomDocument = `
    mutation CancelClassroom($classroomId: String!, $providerArn: String) {
  cancelClassroom(classroomId: $classroomId, providerArn: $providerArn) {
    classroomArn
    providerArn
    langLocale
    courseId
    startsOn
    endsOn
    locationData {
      timezone
      locationType
      virtualUrl
      physicalAddress {
        addressLine1
        addressLine2
        city
        state
        postalCode
        country
        __typename
      }
      source
      __typename
    }
    courseTitle
    createdByEmail
    instructorEmails
    __typename
  }
}
    `;

export const useCancelClassroomMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CancelClassroomMutation,
        TError,
        CancelClassroomMutationVariables,
        TContext
    >,
) => {
    return useMutation<CancelClassroomMutation, TError, CancelClassroomMutationVariables, TContext>(
        ['CancelClassroom'],
        (variables?: CancelClassroomMutationVariables) =>
            fetchData<CancelClassroomMutation, CancelClassroomMutationVariables>(
                CancelClassroomDocument,
                variables,
            )(),
        options,
    );
};

export const AcceptInvitationsDocument = `
    mutation AcceptInvitations {
  acceptInvitations {
    acceptedInvitations {
      email
      invitationArn
      relationship
      resourceArn
      status
      __typename
    }
    __typename
  }
}
    `;

export const useAcceptInvitationsMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        AcceptInvitationsMutation,
        TError,
        AcceptInvitationsMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        AcceptInvitationsMutation,
        TError,
        AcceptInvitationsMutationVariables,
        TContext
    >(
        ['AcceptInvitations'],
        (variables?: AcceptInvitationsMutationVariables) =>
            fetchData<AcceptInvitationsMutation, AcceptInvitationsMutationVariables>(
                AcceptInvitationsDocument,
                variables,
            )(),
        options,
    );
};

export const CreateClassroomRelationshipsDocument = `
    mutation CreateClassroomRelationships($input: CreateClassroomRelationshipsInput!) {
  createClassroomRelationships(input: $input) {
    statusCode
    __typename
  }
}
    `;

export const useCreateClassroomRelationshipsMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CreateClassroomRelationshipsMutation,
        TError,
        CreateClassroomRelationshipsMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        CreateClassroomRelationshipsMutation,
        TError,
        CreateClassroomRelationshipsMutationVariables,
        TContext
    >(
        ['CreateClassroomRelationships'],
        (variables?: CreateClassroomRelationshipsMutationVariables) =>
            fetchData<
                CreateClassroomRelationshipsMutation,
                CreateClassroomRelationshipsMutationVariables
            >(CreateClassroomRelationshipsDocument, variables)(),
        options,
    );
};

export const AddStudentsToClassroomRosterDocument = `
    mutation AddStudentsToClassroomRoster($input: AddStudentsToClassroomRosterInput!) {
  addStudentsToClassroomRoster(input: $input) {
    statusCode
    __typename
  }
}
    `;

export const useAddStudentsToClassroomRosterMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        AddStudentsToClassroomRosterMutation,
        TError,
        AddStudentsToClassroomRosterMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        AddStudentsToClassroomRosterMutation,
        TError,
        AddStudentsToClassroomRosterMutationVariables,
        TContext
    >(
        ['AddStudentsToClassroomRoster'],
        (variables?: AddStudentsToClassroomRosterMutationVariables) =>
            fetchData<
                AddStudentsToClassroomRosterMutation,
                AddStudentsToClassroomRosterMutationVariables
            >(AddStudentsToClassroomRosterDocument, variables)(),
        options,
    );
};

export const CreateStudentTrainingsDocument = `
    mutation CreateStudentTrainings($input: CreateStudentTrainingsInput!) {
  createStudentTrainings(input: $input) {
    batchId
    created
    labPoolBatchInfo {
      batchId
      createdTime
      __typename
    }
    __typename
  }
}
    `;

export const useCreateStudentTrainingsMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CreateStudentTrainingsMutation,
        TError,
        CreateStudentTrainingsMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        CreateStudentTrainingsMutation,
        TError,
        CreateStudentTrainingsMutationVariables,
        TContext
    >(
        ['CreateStudentTrainings'],
        (variables?: CreateStudentTrainingsMutationVariables) =>
            fetchData<CreateStudentTrainingsMutation, CreateStudentTrainingsMutationVariables>(
                CreateStudentTrainingsDocument,
                variables,
            )(),
        options,
    );
};

export const ExcludeUserDocument = `
    mutation ExcludeUser($input: ExcludeUserInput!) {
  excludeUser(input: $input) {
    email
    invitationArn
    relationship
    resourceArn
    status
    __typename
  }
}
    `;

export const useExcludeUserMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        ExcludeUserMutation,
        TError,
        ExcludeUserMutationVariables,
        TContext
    >,
) => {
    return useMutation<ExcludeUserMutation, TError, ExcludeUserMutationVariables, TContext>(
        ['ExcludeUser'],
        (variables?: ExcludeUserMutationVariables) =>
            fetchData<ExcludeUserMutation, ExcludeUserMutationVariables>(
                ExcludeUserDocument,
                variables,
            )(),
        options,
    );
};

export const CancelStudentTrainingsDocument = `
    mutation CancelStudentTrainings($input: CancelStudentTrainingsInput!) {
  cancelStudentTrainings(input: $input) {
    batchId
    created
    __typename
  }
}
    `;

export const useCancelStudentTrainingsMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        CancelStudentTrainingsMutation,
        TError,
        CancelStudentTrainingsMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        CancelStudentTrainingsMutation,
        TError,
        CancelStudentTrainingsMutationVariables,
        TContext
    >(
        ['CancelStudentTrainings'],
        (variables?: CancelStudentTrainingsMutationVariables) =>
            fetchData<CancelStudentTrainingsMutation, CancelStudentTrainingsMutationVariables>(
                CancelStudentTrainingsDocument,
                variables,
            )(),
        options,
    );
};

export const PutTrainingConfigurationDocument = `
    mutation PutTrainingConfiguration($input: PutTrainingConfigurationInput!) {
  putTrainingConfiguration(input: $input) {
    statusCode
    __typename
  }
}
    `;

export const usePutTrainingConfigurationMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        PutTrainingConfigurationMutation,
        TError,
        PutTrainingConfigurationMutationVariables,
        TContext
    >,
) => {
    return useMutation<
        PutTrainingConfigurationMutation,
        TError,
        PutTrainingConfigurationMutationVariables,
        TContext
    >(
        ['PutTrainingConfiguration'],
        (variables?: PutTrainingConfigurationMutationVariables) =>
            fetchData<PutTrainingConfigurationMutation, PutTrainingConfigurationMutationVariables>(
                PutTrainingConfigurationDocument,
                variables,
            )(),
        options,
    );
};

export const ResetResourcesDocument = `
    mutation ResetResources {
  resetResources {
    statusCode
    __typename
  }
}
    `;

export const useResetResourcesMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        ResetResourcesMutation,
        TError,
        ResetResourcesMutationVariables,
        TContext
    >,
) => {
    return useMutation<ResetResourcesMutation, TError, ResetResourcesMutationVariables, TContext>(
        ['ResetResources'],
        (variables?: ResetResourcesMutationVariables) =>
            fetchData<ResetResourcesMutation, ResetResourcesMutationVariables>(
                ResetResourcesDocument,
                variables,
            )(),
        options,
    );
};

export const MarkAttendanceDocument = `
    mutation MarkAttendance($input: MarkAttendanceInput!) {
  markAttendance(input: $input) {
    attendanceRecords {
      id
      version
      attendanceStatus
      attendanceDurationPercentage
      learner {
        id
        emailAddress
        firstName
        lastName
        licenses {
          nodes {
            id
            productModality
            licenseType
            __typename
          }
          __typename
        }
        organizations {
          nodes {
            id
            name
            sfdcAccountId
            __typename
          }
          __typename
        }
        __typename
      }
      amsDeliverySession {
        id
        startTime
        endTime
        learningActivity {
          pk
          attendedCounter
          activity_audience
          activity_modality
          activity_name
          activity_status
          activity_type
          class_size
          course_name
          customers {
            customer_name
            sfdc_account_id
            training_briefing {
              what_the_customer_does
              where_are_they_in_their_cloud_journey
              motivations_for_using_aws
              special_needs_for_training_delivery
              __typename
            }
            __typename
          }
          delivery_address_1
          delivery_address_2
          delivery_city
          delivery_country
          delivery_geo
          delivery_language
          delivery_postal_code
          delivery_region
          delivery_sessions {
            id
            start_timestamp
            end_timestamp
            __typename
          }
          delivery_state
          delivery_timezone
          instructors {
            role
            pk
            type
            email
            __typename
          }
          program
          record_type
          classrooms_student_url
          classrooms_arn
          lms_type
          v_ilt_type
          v_ilt_id
          v_ilt_meeting_id
          registrationCounter
          instructor_notes {
            description
            timestamp
            updated_by
            __typename
          }
          csat {
            overall_score
            instructor_score
            completed_responses
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

export const useMarkAttendanceMutation = <TError = unknown, TContext = unknown>(
    options?: UseMutationOptions<
        MarkAttendanceMutation,
        TError,
        MarkAttendanceMutationVariables,
        TContext
    >,
) => {
    return useMutation<MarkAttendanceMutation, TError, MarkAttendanceMutationVariables, TContext>(
        ['MarkAttendance'],
        (variables?: MarkAttendanceMutationVariables) =>
            fetchData<MarkAttendanceMutation, MarkAttendanceMutationVariables>(
                MarkAttendanceDocument,
                variables,
            )(),
        options,
    );
};

export const GetClassroomDocument = `
    query GetClassroom($classroomId: String!, $providerArn: String) {
  getClassroom(classroomId: $classroomId, providerArn: $providerArn) {
    classroom {
      classroomId
      classroomArn
      langLocale
      courseId
      providerArn
      courseTitle
      courseAbstract
      courseDescription
      courseLevel
      startsOn
      endsOn
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
          __typename
        }
        source
        __typename
      }
      studentGuide {
        custom_vbid
        __typename
      }
      callsToAction {
        locationType
        url
        label
        actionType
        icon
        iconPosition
        __typename
      }
      accessCodes {
        accessCode
        accessCodeCapacity
        accessCodeCapacityUsed
        __typename
      }
      classCapacity
      studentCount
      supportedRegions
      createdBy
      accessType
      isCancellable
      subProviderCapacity {
        subProviderArn
        capacity
        subProviderStudentCount
        __typename
      }
      learningActivityID
      __typename
    }
    course {
      courseId
      title
      description
      langLocale
      abstract
      level
      __typename
    }
    content {
      contentId
      title
      description
      level
      duration
      durationUnit
      isActive
      supportedRegions
      __typename
    }
    jamTrainings {
      trainings {
        context
        trainingId
        trainingType
        contentId
        requestClientToken
        isActive
        fulfillmentStatus
        fulfillmentError {
          message
          code
          __typename
        }
        created
        lastUpdate
        metaData {
          eventId
          eventCode
          eventStatus
          testCloneEventId
          testCloneEventCode
          testCloneEventSuffix
          startsOn
          endsOn
          timezone
          maxTeamSize
          maxExpectedParticipants
          eventURL
          testEventURL
          adminEventURL
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
    `;

export const useGetClassroomQuery = <TData = GetClassroomQuery, TError = unknown>(
    variables: GetClassroomQueryVariables,
    options?: UseQueryOptions<GetClassroomQuery, TError, TData>,
) => {
    return useQuery<GetClassroomQuery, TError, TData>(
        ['GetClassroom', variables],
        fetchData<GetClassroomQuery, GetClassroomQueryVariables>(GetClassroomDocument, variables),
        options,
    );
};

export const GetStudentTrainingsByClassroomIdDocument = `
    query GetStudentTrainingsByClassroomId($classroomId: String!, $accessType: AccessType, $providerArn: String) {
  getStudentTrainingsByClassroomId(
    classroomId: $classroomId
    accessType: $accessType
    providerArn: $providerArn
  ) {
    studentTrainings {
      lastUpdated
      metaData {
        preferredLangLocale
        labId
        labUrl
        labStatus
        region
        labRegions
        targetRegions
        __typename
      }
      trainingId
      context
      created
      requestClientToken
      arn
      state
      fulfillmentStatus
      fulfillmentError {
        message
        name
        __typename
      }
      bunsenLabStatus
      userKey
      studentNumber
      firstName
      lastName
      email
      trainingType
      __typename
    }
    __typename
  }
}
    `;

export const useGetStudentTrainingsByClassroomIdQuery = <
    TData = GetStudentTrainingsByClassroomIdQuery,
    TError = unknown,
>(
    variables: GetStudentTrainingsByClassroomIdQueryVariables,
    options?: UseQueryOptions<GetStudentTrainingsByClassroomIdQuery, TError, TData>,
) => {
    return useQuery<GetStudentTrainingsByClassroomIdQuery, TError, TData>(
        ['GetStudentTrainingsByClassroomId', variables],
        fetchData<
            GetStudentTrainingsByClassroomIdQuery,
            GetStudentTrainingsByClassroomIdQueryVariables
        >(GetStudentTrainingsByClassroomIdDocument, variables),
        options,
    );
};

export const GetIngressUrlDocument = `
    query GetIngressUrl($input: GetIngressUrlInput!) {
  getIngressUrl(input: $input) {
    labId
    consoleUrl
    endsOn
    status
    __typename
  }
}
    `;

export const useGetIngressUrlQuery = <TData = GetIngressUrlQuery, TError = unknown>(
    variables: GetIngressUrlQueryVariables,
    options?: UseQueryOptions<GetIngressUrlQuery, TError, TData>,
) => {
    return useQuery<GetIngressUrlQuery, TError, TData>(
        ['GetIngressUrl', variables],
        fetchData<GetIngressUrlQuery, GetIngressUrlQueryVariables>(
            GetIngressUrlDocument,
            variables,
        ),
        options,
    );
};

export const GetCourseVersionsDocument = `
    query GetCourseVersions($input: GetCourseVersionsInput!) {
  getCourseVersions(input: $input) {
    courseVersions {
      courseId
      versionId
      createdOn
      status
      availability
      __typename
    }
    nextToken
    __typename
  }
}
    `;

export const useGetCourseVersionsQuery = <TData = GetCourseVersionsQuery, TError = unknown>(
    variables: GetCourseVersionsQueryVariables,
    options?: UseQueryOptions<GetCourseVersionsQuery, TError, TData>,
) => {
    return useQuery<GetCourseVersionsQuery, TError, TData>(
        ['GetCourseVersions', variables],
        fetchData<GetCourseVersionsQuery, GetCourseVersionsQueryVariables>(
            GetCourseVersionsDocument,
            variables,
        ),
        options,
    );
};

export const GetCourseVersionDocument = `
    query GetCourseVersion($courseVersionId: String!, $providerArn: String) {
  getCourseVersion(courseVersionId: $courseVersionId, providerArn: $providerArn) {
    courseVersion {
      courseVersionId
      createdOn
      availability
      status
      courseName
      supportedLocales
      blueprintData {
        blueprintName
        arn
        __typename
      }
      resourceData {
        locale
        description
        title
        __typename
      }
      contentVersion
      jamConfig {
        challengeSetID
        __typename
      }
      contentTypes
      __typename
    }
    __typename
  }
}
    `;

export const useGetCourseVersionQuery = <TData = GetCourseVersionQuery, TError = unknown>(
    variables: GetCourseVersionQueryVariables,
    options?: UseQueryOptions<GetCourseVersionQuery, TError, TData>,
) => {
    return useQuery<GetCourseVersionQuery, TError, TData>(
        ['GetCourseVersion', variables],
        fetchData<GetCourseVersionQuery, GetCourseVersionQueryVariables>(
            GetCourseVersionDocument,
            variables,
        ),
        options,
    );
};

export const GetProviderArnsDocument = `
    query GetProviderArns {
  getProviderArns {
    providers
    __typename
  }
}
    `;

export const useGetProviderArnsQuery = <TData = GetProviderArnsQuery, TError = unknown>(
    variables?: GetProviderArnsQueryVariables,
    options?: UseQueryOptions<GetProviderArnsQuery, TError, TData>,
) => {
    return useQuery<GetProviderArnsQuery, TError, TData>(
        variables === undefined ? ['GetProviderArns'] : ['GetProviderArns', variables],
        fetchData<GetProviderArnsQuery, GetProviderArnsQueryVariables>(
            GetProviderArnsDocument,
            variables,
        ),
        options,
    );
};

export const GetProviderDocument = `
    query GetProvider($input: GetProviderInput!) {
  getProvider(input: $input) {
    provider {
      name
      arn
      type
      subProviderData {
        providerName
        providerType
        providerArn
        providerMetaData {
          isParentProvider
          parentProviderArn
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

export const useGetProviderQuery = <TData = GetProviderQuery, TError = unknown>(
    variables: GetProviderQueryVariables,
    options?: UseQueryOptions<GetProviderQuery, TError, TData>,
) => {
    return useQuery<GetProviderQuery, TError, TData>(
        ['GetProvider', variables],
        fetchData<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, variables),
        options,
    );
};

export const GetServiceScheduleDocument = `
    query GetServiceSchedule($input: GetServiceScheduleInput!) {
  getServiceSchedule(input: $input) {
    schedules {
      service
      domain
      endTime
      startTime
      event
      type
      __typename
    }
    __typename
  }
}
    `;

export const useGetServiceScheduleQuery = <TData = GetServiceScheduleQuery, TError = unknown>(
    variables: GetServiceScheduleQueryVariables,
    options?: UseQueryOptions<GetServiceScheduleQuery, TError, TData>,
) => {
    return useQuery<GetServiceScheduleQuery, TError, TData>(
        ['GetServiceSchedule', variables],
        fetchData<GetServiceScheduleQuery, GetServiceScheduleQueryVariables>(
            GetServiceScheduleDocument,
            variables,
        ),
        options,
    );
};

export const GetProviderReportDocument = `
    query GetProviderReport($input: GetProviderReportInput!) {
  getProviderReport(input: $input) {
    presignedUrl
    __typename
  }
}
    `;

export const useGetProviderReportQuery = <TData = GetProviderReportQuery, TError = unknown>(
    variables: GetProviderReportQueryVariables,
    options?: UseQueryOptions<GetProviderReportQuery, TError, TData>,
) => {
    return useQuery<GetProviderReportQuery, TError, TData>(
        ['GetProviderReport', variables],
        fetchData<GetProviderReportQuery, GetProviderReportQueryVariables>(
            GetProviderReportDocument,
            variables,
        ),
        options,
    );
};

export const GetTrainingConfigurationDocument = `
    query GetTrainingConfiguration($input: GetTrainingConfigurationInput!) {
  getTrainingConfiguration(input: $input) {
    context
    contentArn
    contentType
    configuration {
      targetRegions
      __typename
    }
    __typename
  }
}
    `;

export const useGetTrainingConfigurationQuery = <
    TData = GetTrainingConfigurationQuery,
    TError = unknown,
>(
    variables: GetTrainingConfigurationQueryVariables,
    options?: UseQueryOptions<GetTrainingConfigurationQuery, TError, TData>,
) => {
    return useQuery<GetTrainingConfigurationQuery, TError, TData>(
        ['GetTrainingConfiguration', variables],
        fetchData<GetTrainingConfigurationQuery, GetTrainingConfigurationQueryVariables>(
            GetTrainingConfigurationDocument,
            variables,
        ),
        options,
    );
};

export const ListUserRelationshipsDocument = `
    query ListUserRelationships($input: ListUserRelationshipsInput!) {
  listUserRelationships(input: $input) {
    relationships
    __typename
  }
}
    `;

export const useListUserRelationshipsQuery = <TData = ListUserRelationshipsQuery, TError = unknown>(
    variables: ListUserRelationshipsQueryVariables,
    options?: UseQueryOptions<ListUserRelationshipsQuery, TError, TData>,
) => {
    return useQuery<ListUserRelationshipsQuery, TError, TData>(
        ['ListUserRelationships', variables],
        fetchData<ListUserRelationshipsQuery, ListUserRelationshipsQueryVariables>(
            ListUserRelationshipsDocument,
            variables,
        ),
        options,
    );
};

export const ListClassroomRelationshipsDocument = `
    query ListClassroomRelationships($input: ListClassroomRelationshipsInput!) {
  listClassroomRelationships(input: $input) {
    classroomUsers {
      email
      userKey
      firstName
      lastName
      hasAcceptedInvitation
      eKitLicensedProviderArn
      __typename
    }
    emails
    __typename
  }
}
    `;

export const useListClassroomRelationshipsQuery = <
    TData = ListClassroomRelationshipsQuery,
    TError = unknown,
>(
    variables: ListClassroomRelationshipsQueryVariables,
    options?: UseQueryOptions<ListClassroomRelationshipsQuery, TError, TData>,
) => {
    return useQuery<ListClassroomRelationshipsQuery, TError, TData>(
        ['ListClassroomRelationships', variables],
        fetchData<ListClassroomRelationshipsQuery, ListClassroomRelationshipsQueryVariables>(
            ListClassroomRelationshipsDocument,
            variables,
        ),
        options,
    );
};

export const ListUserClassroomsDocument = `
    query ListUserClassrooms($input: ListClassroomsInput!) {
  listUserClassrooms(input: $input) {
    classrooms {
      classroomArn
      providerArn
      langLocale
      courseId
      startsOn
      endsOn
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
          __typename
        }
        source
        __typename
      }
      courseTitle
      createdByEmail
      instructorEmails
      __typename
    }
    nextToken
    __typename
  }
}
    `;

export const useListUserClassroomsQuery = <TData = ListUserClassroomsQuery, TError = unknown>(
    variables: ListUserClassroomsQueryVariables,
    options?: UseQueryOptions<ListUserClassroomsQuery, TError, TData>,
) => {
    return useQuery<ListUserClassroomsQuery, TError, TData>(
        ['ListUserClassrooms', variables],
        fetchData<ListUserClassroomsQuery, ListUserClassroomsQueryVariables>(
            ListUserClassroomsDocument,
            variables,
        ),
        options,
    );
};

export const ListProviderClassroomsDocument = `
    query ListProviderClassrooms($input: ListClassroomsInput!) {
  listProviderClassrooms(input: $input) {
    classrooms {
      classroomArn
      providerArn
      langLocale
      courseId
      startsOn
      endsOn
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
          __typename
        }
        source
        __typename
      }
      courseTitle
      createdByEmail
      instructorEmails
      __typename
    }
    nextToken
    __typename
  }
}
    `;

export const useListProviderClassroomsQuery = <
    TData = ListProviderClassroomsQuery,
    TError = unknown,
>(
    variables: ListProviderClassroomsQueryVariables,
    options?: UseQueryOptions<ListProviderClassroomsQuery, TError, TData>,
) => {
    return useQuery<ListProviderClassroomsQuery, TError, TData>(
        ['ListProviderClassrooms', variables],
        fetchData<ListProviderClassroomsQuery, ListProviderClassroomsQueryVariables>(
            ListProviderClassroomsDocument,
            variables,
        ),
        options,
    );
};

export const ListProviderReportsDocument = `
    query ListProviderReports($input: ListProviderReportsInput!) {
  listProviderReports(input: $input) {
    iltReports {
      reportId
      reportName
      reportDate
      reportDescription
      createdDate
      __typename
    }
    nextToken
    __typename
  }
}
    `;

export const useListProviderReportsQuery = <TData = ListProviderReportsQuery, TError = unknown>(
    variables: ListProviderReportsQueryVariables,
    options?: UseQueryOptions<ListProviderReportsQuery, TError, TData>,
) => {
    return useQuery<ListProviderReportsQuery, TError, TData>(
        ['ListProviderReports', variables],
        fetchData<ListProviderReportsQuery, ListProviderReportsQueryVariables>(
            ListProviderReportsDocument,
            variables,
        ),
        options,
    );
};

export const ListCoursesDocument = `
    query ListCourses($input: ListCoursesInput!) {
  listCourses(input: $input) {
    courses {
      title
      id
      __typename
    }
    __typename
  }
}
    `;

export const useListCoursesQuery = <TData = ListCoursesQuery, TError = unknown>(
    variables: ListCoursesQueryVariables,
    options?: UseQueryOptions<ListCoursesQuery, TError, TData>,
) => {
    return useQuery<ListCoursesQuery, TError, TData>(
        ['ListCourses', variables],
        fetchData<ListCoursesQuery, ListCoursesQueryVariables>(ListCoursesDocument, variables),
        options,
    );
};

export const ListMajorCourseVersionsDocument = `
    query ListMajorCourseVersions($input: ListMajorCourseVersionsInput) {
  listMajorCourseVersions(input: $input) {
    collections {
      collectionArn
      collectionTitle
      supportedLangLocales
      courseTemplatePk
      __typename
    }
    nextToken
    __typename
  }
}
    `;

export const useListMajorCourseVersionsQuery = <
    TData = ListMajorCourseVersionsQuery,
    TError = unknown,
>(
    variables?: ListMajorCourseVersionsQueryVariables,
    options?: UseQueryOptions<ListMajorCourseVersionsQuery, TError, TData>,
) => {
    return useQuery<ListMajorCourseVersionsQuery, TError, TData>(
        variables === undefined
            ? ['ListMajorCourseVersions']
            : ['ListMajorCourseVersions', variables],
        fetchData<ListMajorCourseVersionsQuery, ListMajorCourseVersionsQueryVariables>(
            ListMajorCourseVersionsDocument,
            variables,
        ),
        options,
    );
};

export const ListInstructorClassroomsV2Document = `
    query ListInstructorClassroomsV2($input: ListInstructorClassroomsV2Input!) {
  listInstructorClassroomsV2(input: $input) {
    classrooms {
      classroomArn
      providerArn
      langLocale
      courseId
      startsOn
      endsOn
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
          __typename
        }
        source
        __typename
      }
      courseTitle
      createdByEmail
      instructorEmails
      __typename
    }
    count
    countType
    aggregations {
      courseTitle {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      langLocale {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      country {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

export const useListInstructorClassroomsV2Query = <
    TData = ListInstructorClassroomsV2Query,
    TError = unknown,
>(
    variables: ListInstructorClassroomsV2QueryVariables,
    options?: UseQueryOptions<ListInstructorClassroomsV2Query, TError, TData>,
) => {
    return useQuery<ListInstructorClassroomsV2Query, TError, TData>(
        ['ListInstructorClassroomsV2', variables],
        fetchData<ListInstructorClassroomsV2Query, ListInstructorClassroomsV2QueryVariables>(
            ListInstructorClassroomsV2Document,
            variables,
        ),
        options,
    );
};

export const ListProviderClassroomsV2Document = `
    query ListProviderClassroomsV2($input: ListProviderClassroomsV2Input!) {
  listProviderClassroomsV2(input: $input) {
    classrooms {
      classroomArn
      providerArn
      langLocale
      courseId
      startsOn
      endsOn
      locationData {
        timezone
        locationType
        virtualUrl
        physicalAddress {
          addressLine1
          addressLine2
          city
          state
          postalCode
          country
          __typename
        }
        source
        __typename
      }
      courseTitle
      createdByEmail
      instructorEmails
      __typename
    }
    count
    countType
    aggregations {
      courseTitle {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      langLocale {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      country {
        items {
          value
          count
          __typename
        }
        countType
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

export const useListProviderClassroomsV2Query = <
    TData = ListProviderClassroomsV2Query,
    TError = unknown,
>(
    variables: ListProviderClassroomsV2QueryVariables,
    options?: UseQueryOptions<ListProviderClassroomsV2Query, TError, TData>,
) => {
    return useQuery<ListProviderClassroomsV2Query, TError, TData>(
        ['ListProviderClassroomsV2', variables],
        fetchData<ListProviderClassroomsV2Query, ListProviderClassroomsV2QueryVariables>(
            ListProviderClassroomsV2Document,
            variables,
        ),
        options,
    );
};

export const RequiresResetDocument = `
    query RequiresReset {
  requiresReset {
    requiresReset
    __typename
  }
}
    `;

export const useRequiresResetQuery = <TData = RequiresResetQuery, TError = unknown>(
    variables?: RequiresResetQueryVariables,
    options?: UseQueryOptions<RequiresResetQuery, TError, TData>,
) => {
    return useQuery<RequiresResetQuery, TError, TData>(
        variables === undefined ? ['RequiresReset'] : ['RequiresReset', variables],
        fetchData<RequiresResetQuery, RequiresResetQueryVariables>(
            RequiresResetDocument,
            variables,
        ),
        options,
    );
};

export const CourseVirtualSkuInfoDocument = `
    query CourseVirtualSKUInfo($input: CourseVirtualSKUInfoInput!) {
  courseVirtualSKUInfo(input: $input) {
    productId
    availableQuantity
    __typename
  }
}
    `;

export const useCourseVirtualSkuInfoQuery = <TData = CourseVirtualSkuInfoQuery, TError = unknown>(
    variables: CourseVirtualSkuInfoQueryVariables,
    options?: UseQueryOptions<CourseVirtualSkuInfoQuery, TError, TData>,
) => {
    return useQuery<CourseVirtualSkuInfoQuery, TError, TData>(
        ['CourseVirtualSKUInfo', variables],
        fetchData<CourseVirtualSkuInfoQuery, CourseVirtualSkuInfoQueryVariables>(
            CourseVirtualSkuInfoDocument,
            variables,
        ),
        options,
    );
};

export const GetLearningActivityDocument = `
    query GetLearningActivity($input: GetLearningActivityInput!) {
  getLearningActivity(input: $input) {
    pk
    attendedCounter
    activity_audience
    activity_modality
    activity_name
    activity_status
    activity_type
    class_size
    course_name
    customers {
      customer_name
      sfdc_account_id
      training_briefing {
        what_the_customer_does
        where_are_they_in_their_cloud_journey
        motivations_for_using_aws
        special_needs_for_training_delivery
        __typename
      }
      __typename
    }
    delivery_address_1
    delivery_address_2
    delivery_city
    delivery_country
    delivery_geo
    delivery_language
    delivery_postal_code
    delivery_region
    delivery_sessions {
      id
      start_timestamp
      end_timestamp
      __typename
    }
    delivery_state
    delivery_timezone
    instructors {
      role
      pk
      type
      email
      __typename
    }
    program
    record_type
    classrooms_student_url
    classrooms_arn
    lms_type
    v_ilt_type
    v_ilt_id
    v_ilt_meeting_id
    registrationCounter
    instructor_notes {
      description
      timestamp
      updated_by
      __typename
    }
    csat {
      overall_score
      instructor_score
      completed_responses
      __typename
    }
    __typename
  }
}
    `;

export const useGetLearningActivityQuery = <TData = GetLearningActivityQuery, TError = unknown>(
    variables: GetLearningActivityQueryVariables,
    options?: UseQueryOptions<GetLearningActivityQuery, TError, TData>,
) => {
    return useQuery<GetLearningActivityQuery, TError, TData>(
        ['GetLearningActivity', variables],
        fetchData<GetLearningActivityQuery, GetLearningActivityQueryVariables>(
            GetLearningActivityDocument,
            variables,
        ),
        options,
    );
};

export const GetClassAttendanceDocument = `
    query GetClassAttendance($input: GetClassAttendanceInput!) {
  getClassAttendance(input: $input) {
    learningActivityAttendanceRecords {
      learner {
        id
        emailAddress
        firstName
        lastName
        licenses {
          nodes {
            id
            productModality
            licenseType
            __typename
          }
          __typename
        }
        organizations {
          nodes {
            id
            name
            sfdcAccountId
            __typename
          }
          __typename
        }
        evaluationStatus
        __typename
      }
      learningActivityAttendanceStatus
      deliverySessionAttendanceRecords {
        id
        version
        attendanceStatus
        attendanceDurationPercentage
        learner {
          id
          emailAddress
          firstName
          lastName
          licenses {
            nodes {
              id
              productModality
              licenseType
              __typename
            }
            __typename
          }
          organizations {
            nodes {
              id
              name
              sfdcAccountId
              __typename
            }
            __typename
          }
          __typename
        }
        amsDeliverySession {
          id
          startTime
          endTime
          learningActivity {
            pk
            attendedCounter
            activity_audience
            activity_modality
            activity_name
            activity_status
            activity_type
            class_size
            course_name
            customers {
              customer_name
              sfdc_account_id
              __typename
            }
            delivery_address_1
            delivery_address_2
            delivery_city
            delivery_country
            delivery_geo
            delivery_language
            delivery_postal_code
            delivery_region
            delivery_sessions {
              id
              start_timestamp
              end_timestamp
              __typename
            }
            delivery_state
            delivery_timezone
            instructors {
              role
              pk
              type
              email
              __typename
            }
            program
            record_type
            classrooms_student_url
            classrooms_arn
            lms_type
            v_ilt_type
            v_ilt_id
            v_ilt_meeting_id
            registrationCounter
            instructor_notes {
              description
              timestamp
              updated_by
              __typename
            }
            csat {
              overall_score
              instructor_score
              completed_responses
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    pageInfo {
      cursor
      size
      __typename
    }
    __typename
  }
}
    `;

export const useGetClassAttendanceQuery = <TData = GetClassAttendanceQuery, TError = unknown>(
    variables: GetClassAttendanceQueryVariables,
    options?: UseQueryOptions<GetClassAttendanceQuery, TError, TData>,
) => {
    return useQuery<GetClassAttendanceQuery, TError, TData>(
        ['GetClassAttendance', variables],
        fetchData<GetClassAttendanceQuery, GetClassAttendanceQueryVariables>(
            GetClassAttendanceDocument,
            variables,
        ),
        options,
    );
};

export const GetFeatureFlagsDocument = `
    query GetFeatureFlags {
  getFeatureFlags {
    flag
    enabled
    __typename
  }
}
    `;

export const useGetFeatureFlagsQuery = <TData = GetFeatureFlagsQuery, TError = unknown>(
    variables?: GetFeatureFlagsQueryVariables,
    options?: UseQueryOptions<GetFeatureFlagsQuery, TError, TData>,
) => {
    return useQuery<GetFeatureFlagsQuery, TError, TData>(
        variables === undefined ? ['GetFeatureFlags'] : ['GetFeatureFlags', variables],
        fetchData<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(
            GetFeatureFlagsDocument,
            variables,
        ),
        options,
    );
};

export const BatchGetUserInfoDocument = `
    query BatchGetUserInfo($input: BatchGetUserInfoInput!) {
  batchGetUserInfo(input: $input) {
    users {
      id
      emailAddress
      firstName
      lastName
      licenses {
        nodes {
          id
          productModality
          licenseType
          __typename
        }
        __typename
      }
      organizations {
        nodes {
          id
          name
          sfdcAccountId
          __typename
        }
        __typename
      }
      __typename
    }
    failedUsers {
      id
      error
      __typename
    }
    __typename
  }
}
    `;

export const useBatchGetUserInfoQuery = <TData = BatchGetUserInfoQuery, TError = unknown>(
    variables: BatchGetUserInfoQueryVariables,
    options?: UseQueryOptions<BatchGetUserInfoQuery, TError, TData>,
) => {
    return useQuery<BatchGetUserInfoQuery, TError, TData>(
        ['BatchGetUserInfo', variables],
        fetchData<BatchGetUserInfoQuery, BatchGetUserInfoQueryVariables>(
            BatchGetUserInfoDocument,
            variables,
        ),
        options,
    );
};

export const OnUpdateTrainingPermissionsDocument = `
    subscription OnUpdateTrainingPermissions {
  onUpdateTrainingPermissions {
    classroomId
    providerArn
    activeTrainings
    status
    __typename
  }
}
    `;
